import { html as runeHtml } from 'rune-ts';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { html as fxjsHtml } from 'fxjs/es';
import iconKlass from './Icons.module.scss';

type IconProps = {
  html?: typeof runeHtml | typeof fxjsHtml;
  klass?: string;
};

export const adultIcon = ({ html = runeHtml, klass = iconKlass.adult }: IconProps = {}) => html`
  <div class="${klass}">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 12 9" fill="none">
      <path
        d="M7.97437 8.22211e-05C9.73218 0.011801 11.3962 1.05477 11.3962 4.1368C11.408 7.01961 10.0369 8.71883 7.90405 8.71883C6.19312 8.71883 5.03296 7.65243 4.85718 6.21102H6.59155C6.73218 6.83211 7.22437 7.20711 7.90405 7.20711C9.06421 7.20711 9.67358 6.17586 9.67358 4.47664H9.60327C9.20483 5.22664 8.3728 5.67196 7.42358 5.67196C5.90015 5.67196 4.77515 4.52352 4.76343 2.94149C4.76343 1.23055 6.05249 -0.0116365 7.97437 8.22211e-05ZM7.98608 1.38289C7.1189 1.38289 6.47437 2.05086 6.48608 2.89461C6.48608 3.72664 7.10718 4.38289 7.97437 4.38289C8.82983 4.38289 9.4978 3.70321 9.4978 2.88289C9.48608 2.0743 8.85327 1.38289 7.98608 1.38289Z"
        fill="currentColor"
      />
      <path
        d="M3.76172 0.117188V8.60156H1.99219V1.79297H1.94531L0 3.01172V1.45312L2.09766 0.117188H3.76172Z"
        fill="currentColor"
      />
    </svg>
  </div>
`;

export const shareIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    width="100%"
    height="100%"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3171 10.1106L13.0671 16.3606C12.9797 16.4482 12.8683 16.5078 12.747 16.5319C12.6257 16.5561 12.5 16.5437 12.3857 16.4963C12.2714 16.449 12.1738 16.3688 12.1051 16.2659C12.0365 16.1631 11.9999 16.0421 12 15.9185V12.8114C7.53901 13.0646 4.48042 15.9575 3.62183 16.8739C3.48701 17.0179 3.31021 17.1157 3.11659 17.1534C2.92298 17.1911 2.72241 17.1667 2.54343 17.0838C2.36446 17.0009 2.21619 16.8636 2.11974 16.6916C2.02328 16.5195 1.98355 16.3214 2.0062 16.1255C2.29605 13.6052 3.67651 11.181 5.8937 9.29971C7.73511 7.73721 9.97339 6.7458 12 6.57237V3.41846C11.9999 3.29478 12.0365 3.17384 12.1051 3.07097C12.1738 2.9681 12.2714 2.88792 12.3857 2.84057C12.5 2.79323 12.6257 2.78085 12.747 2.80501C12.8683 2.82916 12.9797 2.88877 13.0671 2.97627L19.3171 9.22627C19.3752 9.28432 19.4213 9.35325 19.4528 9.42912C19.4843 9.505 19.5004 9.58633 19.5004 9.66846C19.5004 9.7506 19.4843 9.83192 19.4528 9.9078C19.4213 9.98367 19.3752 10.0526 19.3171 10.1106Z"
      fill="currentColor"
    />
  </svg>
`;

export const publishingIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M3.94905 2.71113C4.08944 2.91704 4.03629 3.19719 3.84571 3.35694C2.75687 4.26967 2.06345 5.64529 2.06345 7.18451C2.06352 8.72349 2.75711 10.0985 3.84578 11.0112C4.03633 11.1709 4.08946 11.4511 3.94908 11.657C3.80849 11.8632 3.52736 11.9166 3.33437 11.7592C2.01196 10.6812 1.16608 9.03257 1.16602 7.18451C1.16602 5.33617 2.01176 3.68696 3.33439 2.60883C3.52738 2.45152 3.80847 2.50494 3.94905 2.71113Z"
      fill="#FF6A00"
    />
    <path
      d="M10.0492 2.7111C10.1898 2.50493 10.4709 2.4515 10.6639 2.60878C11.9867 3.68688 12.8327 5.33603 12.8327 7.18451C12.8326 9.03283 11.9864 10.6814 10.6636 11.7595C10.4708 11.9167 10.1898 11.8633 10.0493 11.6573C9.90885 11.4515 9.96196 11.1714 10.1525 11.0117C11.2414 10.099 11.9352 8.72372 11.9352 7.18451C11.9352 5.64517 11.2416 4.26963 10.1526 3.35693C9.962 3.19719 9.90883 2.91703 10.0492 2.7111Z"
      fill="#FF6A00"
    />
    <path
      d="M8.77787 4.57487C8.91829 4.36898 9.19996 4.315 9.38508 4.48112C10.1237 5.14388 10.5891 6.10922 10.5891 7.18451C10.5891 8.25943 10.1239 9.2244 9.38579 9.88712C9.20056 10.0534 8.91865 9.99938 8.77818 9.79329C8.63791 9.58752 8.69277 9.30844 8.8708 9.13487C9.37683 8.64154 9.69166 7.95027 9.69166 7.18451C9.69166 6.41845 9.37677 5.72668 8.87046 5.23321C8.69242 5.05968 8.63756 4.78059 8.77787 4.57487Z"
      fill="#FF6A00"
    />
    <path
      d="M5.22009 4.57529C5.36035 4.78107 5.3055 5.06014 5.12752 5.23374C4.62161 5.72719 4.30704 6.41878 4.30704 7.18451C4.30704 7.95019 4.62171 8.64153 5.1276 9.1349C5.30555 9.30844 5.36032 9.58745 5.22005 9.79312C5.07959 9.99906 4.79781 10.053 4.61269 9.88679C3.8747 9.22409 3.40961 8.25929 3.40961 7.18451C3.40961 6.10964 3.87446 5.14432 4.61249 4.4815C4.79769 4.31516 5.07962 4.36921 5.22009 4.57529Z"
      fill="#FF6A00"
    />
    <path
      d="M6.99935 5.82735C7.74281 5.82735 8.3455 6.43497 8.3455 7.18451C8.3455 7.93405 7.74281 8.54167 6.99935 8.54167C6.25589 8.54167 5.6532 7.93405 5.6532 7.18451C5.6532 6.43497 6.25589 5.82735 6.99935 5.82735Z"
      fill="#FF6A00"
    />
  </svg>
`;

export const systemIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 17"
    fill="none"
  >
    <g id="System Icon" clip-path="url(#clip0_2334_42256)">
      <g id="Vector">
        <path
          d="M14.0802 8.48665C13.7602 8.48665 13.4936 8.74665 13.4936 9.07331V13.76C13.4936 13.8933 13.3469 14.0066 13.1736 14.0066H2.82024C2.6469 14.0066 2.50024 13.8933 2.50024 13.76V9.07331C2.50024 8.75331 2.24024 8.48665 1.91357 8.48665C1.5869 8.48665 1.3269 8.74665 1.3269 9.07331V13.76C1.3269 14.54 1.99357 15.1733 2.81357 15.1733H13.1669C13.9869 15.1733 14.6536 14.54 14.6536 13.76V9.07331C14.6536 8.75331 14.3936 8.48665 14.0669 8.48665H14.0802Z"
          fill="currentColor"
        />
        <path
          d="M7.5869 11.38C7.64024 11.4333 7.7069 11.4733 7.77357 11.5066C7.8469 11.5333 7.92024 11.5533 8.00024 11.5533C8.08024 11.5533 8.15357 11.54 8.2269 11.5066C8.30024 11.48 8.36024 11.4333 8.41357 11.38L10.5869 9.20665C10.8136 8.97998 10.8136 8.60665 10.5869 8.37998C10.3602 8.15331 9.98691 8.15331 9.76024 8.37998L8.5869 9.55331V2.41998C8.5869 2.09998 8.3269 1.83331 8.00024 1.83331C7.67357 1.83331 7.41357 2.09331 7.41357 2.41998V9.56665L6.24024 8.39331C6.01357 8.16665 5.64024 8.16665 5.41357 8.39331C5.1869 8.61998 5.1869 8.99331 5.41357 9.21998L7.5869 11.3933V11.38Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2334_42256">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
`;
export const mspLogoIconV1 = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 78 40"
    fill="none"
  >
    <g id="Vector">
      <path
        d="M71.7411 26.1642C72.2559 25.5127 72.7441 24.8463 73.2031 24.1636C73.221 24.1369 73.2397 24.1106 73.2575 24.0839C73.2729 24.0609 73.2875 24.0376 73.3027 24.0145C74.0601 22.873 74.7317 21.6839 75.2995 20.4384C75.7826 19.3784 76.1916 18.2782 76.51 17.1293C77.4343 13.7937 77.5212 10.4615 76.208 7.22471C74.233 2.35664 69.8721 0 65.5218 0C61.5639 0 57.6149 1.94883 55.4746 5.73018C55.4336 5.80255 55.3915 5.8743 55.346 5.95104C55.2803 6.06188 55.1197 6.06188 55.054 5.95104C55.0085 5.8743 54.9663 5.80255 54.9254 5.73018C52.7853 1.94932 48.8356 0 44.8782 0C40.5273 0 36.1672 2.35615 34.192 7.22471C32.8788 10.4615 32.9657 13.7937 33.89 17.1293C34.2084 18.2782 34.6174 19.3784 35.1005 20.4384C35.6683 21.6839 36.3399 22.873 37.0973 24.0146C37.1125 24.0376 37.1271 24.0609 37.1425 24.0839C37.1602 24.1106 37.179 24.1369 37.1969 24.1636C37.6558 24.8463 38.1441 25.5127 38.6589 26.1642C43.1721 31.876 48.7704 36.2798 54.9649 39.9517C55.0233 39.9862 55.1072 40 55.1896 40C55.191 40 55.1924 39.9998 55.1937 39.9998L55.1948 40C55.1955 40 55.1961 39.9996 55.1967 39.9996C55.2943 39.9987 55.3889 39.979 55.4351 39.9517C61.6296 36.2798 67.2279 31.876 71.7411 26.1642ZM37.7694 19.5301C37.7267 19.3428 37.6459 19.1703 37.5363 19.0198C37.5295 19.0105 37.5236 19.0004 37.519 18.9898C37.142 18.1284 36.832 17.2607 36.5884 16.3815C36.2646 15.2132 36.0754 14.103 36.0196 13.0421C36.0119 12.8947 36.18 12.8068 36.2947 12.8995C38.161 14.4085 40.968 15.5679 44.2159 16.3576C44.2858 16.3746 44.3373 16.4336 44.3443 16.5052C44.3977 17.0559 44.465 17.6071 44.545 18.1585C44.9084 20.6631 45.5055 22.9275 46.2561 25.0289C46.3016 25.1563 46.1876 25.2836 46.0562 25.2515C44.7536 24.9333 43.5404 24.5458 42.4485 24.0905C42.4356 24.0851 42.4228 24.0798 42.4099 24.0744C40.4224 23.2404 38.8172 21.695 37.8739 19.757C37.8424 19.6923 37.8113 19.6275 37.7805 19.5628C37.7756 19.5523 37.7719 19.5414 37.7694 19.5301ZM47.4349 9.28135C48.1789 5.77881 49.5348 4.6 50.0391 4.6C50.4499 4.6 51.6092 5.47324 52.378 8.06768C52.4084 8.17012 52.4398 8.27148 52.4753 8.38535L52.5241 8.54287C52.8859 9.71729 53.9712 10.5185 55.2 10.5185C56.4288 10.5185 57.5141 9.71729 57.8759 8.54287L57.9247 8.38535C57.9602 8.27148 57.9916 8.17012 58.0219 8.06787C58.7908 5.47324 59.9501 4.6 60.3608 4.6C60.8651 4.6 62.2211 5.77881 62.9651 9.28145C63.2775 10.7521 63.4206 12.3025 63.3974 13.9614C63.3963 14.0433 63.3372 14.1137 63.2565 14.128C60.7691 14.5674 58.0345 14.7991 55.2 14.7991C52.3655 14.7991 49.6309 14.5674 47.1435 14.128C47.0628 14.1137 47.0037 14.0433 47.0026 13.9614C46.9794 12.3025 47.1225 10.7521 47.4349 9.28135ZM55.2 17.5991C57.8101 17.5991 60.4611 17.3959 62.9666 16.9978C63.078 16.9802 63.1751 17.0732 63.161 17.1851C63.1372 17.3741 63.1119 17.5644 63.084 17.7565C62.6871 20.4925 61.9672 23.0962 60.8832 25.7165C60.8829 25.7172 60.8826 25.7178 60.8824 25.7185C60.8321 25.8396 60.7196 25.9236 60.5895 25.9403C58.87 26.1616 57.0587 26.278 55.2 26.278C53.3412 26.278 51.5301 26.1616 49.8105 25.9403C49.6804 25.9236 49.5679 25.8396 49.5176 25.7184C49.5174 25.7178 49.5171 25.7171 49.5168 25.7164C48.4328 23.0962 47.7129 20.4925 47.316 17.7565C47.2881 17.5644 47.2628 17.3741 47.2389 17.1851C47.2248 17.0732 47.322 16.9802 47.4334 16.9978C49.9389 17.3959 52.5899 17.5991 55.2 17.5991ZM73.8116 16.3816C73.568 17.2607 73.258 18.1283 72.881 18.9898C72.8764 19.0004 72.8705 19.0105 72.8637 19.0198C72.7541 19.1702 72.6732 19.3428 72.6305 19.5302C72.628 19.5414 72.6243 19.5524 72.6194 19.5628C72.5888 19.6274 72.5577 19.692 72.5263 19.7565C71.5831 21.6948 69.9778 23.2404 67.9901 24.0744C67.9772 24.0798 67.9644 24.0852 67.9515 24.0905C66.8596 24.5458 65.6465 24.9333 64.3438 25.2515C64.2124 25.2836 64.0984 25.1563 64.1439 25.0289C64.8945 22.9275 65.4916 20.6631 65.855 18.1585C65.935 17.6071 66.0023 17.0559 66.0557 16.5052C66.0627 16.4336 66.1142 16.3746 66.1841 16.3576C69.432 15.5679 72.239 14.4085 74.1053 12.8995C74.22 12.8068 74.3881 12.8947 74.3804 13.0421C74.3246 14.103 74.1354 15.2132 73.8116 16.3816ZM59.2939 29.1563C58.1405 31.4167 56.8302 33.5253 55.3365 35.5077C55.2685 35.598 55.1315 35.598 55.0635 35.5077C53.5699 33.5253 52.2595 31.4166 51.1061 29.1563C51.0455 29.0375 51.1394 28.8985 51.2722 28.9099C52.5525 29.0199 53.8661 29.078 55.2 29.078C56.534 29.078 57.8475 29.0199 59.1278 28.9099C59.2606 28.8985 59.3545 29.0375 59.2939 29.1563ZM47.6878 28.5236C48.3796 30.037 49.1151 31.4498 49.8885 32.7747C49.9826 32.9359 49.7856 33.1079 49.6377 32.9941C47.5303 31.3735 45.6228 29.6792 43.8991 27.8976C43.7777 27.7721 43.8992 27.5675 44.0668 27.6163C45.1701 27.9379 46.3409 28.2095 47.564 28.4276C47.6184 28.4373 47.6648 28.4733 47.6878 28.5236ZM62.836 28.4276C64.0591 28.2095 65.2298 27.9379 66.333 27.6164C66.5007 27.5675 66.6221 27.7721 66.5007 27.8976C64.7771 29.6792 62.8698 31.3734 60.7624 32.9939C60.6145 33.1077 60.4175 32.9357 60.5116 32.7745C61.285 31.4496 62.0204 30.0369 62.7122 28.5236C62.7352 28.4733 62.7816 28.4373 62.836 28.4276ZM73.6134 8.27735C73.6138 8.27827 73.6141 8.2792 73.6145 8.28013C73.6996 8.49029 73.7219 8.72416 73.6659 8.94385C73.3411 10.217 71.5688 11.5726 68.784 12.6452C68.043 12.9306 67.2483 13.1879 66.4119 13.4192C66.3045 13.4488 66.1982 13.3684 66.1967 13.2569C66.1759 11.7231 66.0228 10.2005 65.704 8.69961C65.1823 6.24331 64.3274 4.45662 63.3163 3.31758C63.2318 3.22232 63.2782 3.07013 63.4023 3.04126C64.0818 2.88312 64.7915 2.8 65.5218 2.8C67.2305 2.8 68.8661 3.26641 70.2518 4.14873C71.7607 5.10957 72.8918 6.49863 73.6134 8.27735ZM40.1481 4.14844C41.5336 3.26631 43.1692 2.8 44.8782 2.8C45.6084 2.8 46.318 2.88312 46.9975 3.04126C47.1216 3.07013 47.1681 3.22232 47.0835 3.31757C46.0725 4.45652 45.2178 6.24305 44.696 8.69961C44.3772 10.2005 44.2241 11.7231 44.2033 13.257C44.2017 13.3684 44.0955 13.4488 43.9881 13.4192C43.1517 13.1879 42.357 12.9306 41.616 12.6452C38.8312 11.5726 37.0589 10.217 36.7341 8.94385C36.6781 8.72416 36.7004 8.49029 36.7855 8.28013C36.7859 8.2792 36.7862 8.27828 36.7866 8.27735C37.5083 6.49835 38.6394 5.10918 40.1481 4.14844Z"
        fill="currentColor"
      />
      <path
        d="M20.3312 0C20.139 0 19.974 0.13659 19.9382 0.325336L14.7965 27.387C14.7553 27.6039 14.4447 27.6039 14.4035 27.387L9.26181 0.325336C9.22595 0.13659 9.06097 0 8.86884 0H0.4C0.179086 0 0 0.179086 0 0.4V39.6C0 39.8209 0.179086 40 0.4 40H5.6C5.82091 40 6 39.8209 6 39.6V14.0198C6 13.7782 6.34874 13.7437 6.39612 13.9806L11.5357 39.6784C11.5731 39.8654 11.7372 40 11.9279 40H17.2721C17.4627 40 17.6269 39.8654 17.6643 39.6784L22.8039 13.9806C22.8513 13.7437 23.2 13.7782 23.2 14.0198V39.6C23.2 39.8209 23.3791 40 23.6 40H28.8C29.0209 40 29.2 39.8209 29.2 39.6V0.4C29.2 0.179086 29.0209 0 28.8 0H20.3312Z"
        fill="currentColor"
      />
    </g>
  </svg>
`;

const fillColors = {
  gray: '#6B6B6B',
  blue: '#1C75FF',
  white: '#ffffff',
  gray20: '#D9D9D9',
  gray50: '#A2A2A2',
};

type FanIconProps = IconProps & { color?: keyof typeof fillColors };

export const myFanIconHeart = ({ html = runeHtml, color = 'gray' }: FanIconProps = {}) =>
  html` <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Heart">
      <path
        id="Vector"
        d="M21.5327 7.26C20.6335 5.06 18.6552 4 16.6768 4C14.8783 4 13.0898 4.88 12.1106 6.58C12.0907 6.61 12.0707 6.65 12.0507 6.68C12.0307 6.71 12.0107 6.72 11.9808 6.72C11.9508 6.72 11.9308 6.71 11.9108 6.68C11.8908 6.65 11.8708 6.61 11.8509 6.58C10.8817 4.88 9.08319 4 7.2847 4C5.32634 4 3.348 5.06 2.44876 7.26C1.23977 10.22 2.65858 13.49 4.50703 15.86C8.22391 20.28 11.2514 21.71 11.8808 21.98C11.9608 22.01 12.0407 22.01 12.1206 21.98C12.7501 21.72 15.7676 20.29 19.4944 15.86C21.3329 13.49 22.7617 10.22 21.5527 7.26H21.5327Z"
        fill="${fillColors[color]}"
      />
    </g>
  </svg>`;

export const plusIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_11381_99429)">
      <path
        d="M21.12 11.12H12.87V2.88C12.87 2.4 12.48 2 11.99 2C11.5 2 11.11 2.39 11.11 2.88V11.13H2.88C2.4 11.13 2 11.52 2 12.01C2 12.5 2.39 12.89 2.88 12.89H11.13V21.14C11.13 21.62 11.52 22.02 12.01 22.02C12.5 22.02 12.89 21.63 12.89 21.14V12.89H21.14C21.62 12.89 22.02 12.5 22.02 12.01C22.02 11.52 21.63 11.13 21.14 11.13L21.12 11.12Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_11381_99429">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const SearchIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.74 20.5007L17.79 16.5527C19.05 15.0135 19.81 13.0445 19.81 10.9055C19.82 5.998 15.83 2 10.91 2C5.99 2 2 5.998 2 10.9055C2 15.8131 6 19.8111 10.91 19.8111C13.05 19.8111 15.02 19.0515 16.56 17.7921L20.51 21.7401C20.68 21.91 20.91 22 21.13 22C21.35 22 21.58 21.91 21.75 21.7401C22.09 21.4003 22.09 20.8406 21.75 20.5007H21.74ZM3.75 10.9055C3.75 6.95752 6.96 3.74913 10.91 3.74913C14.86 3.74913 18.07 6.95752 18.07 10.9055C18.07 14.8536 14.86 18.062 10.91 18.062C6.96 18.062 3.75 14.8536 3.75 10.9055Z"
      fill="currentColor"
    />
  </svg>
`;
export const ArrowLeftIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1376)">
      <path
        d="M11.88 20.88C11.66 20.88 11.43 20.79 11.26 20.62L3.26 12.62C3.18 12.54 3.11 12.44 3.07 12.33C3.03 12.23 3.01 12.13 3 12.02V11.99C3 11.88 3.03 11.77 3.07 11.68C3.11 11.57 3.18 11.48 3.26 11.39L11.26 3.38C11.6 3.04 12.16 3.04 12.5 3.38C12.84 3.72 12.84 4.28 12.5 4.62L5.99 11.13H20.13C20.61 11.13 21.01 11.52 21.01 12.01C21.01 12.5 20.62 12.89 20.13 12.89H5.99L12.5 19.4C12.84 19.74 12.84 20.3 12.5 20.64C12.33 20.81 12.1 20.9 11.88 20.9V20.88Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1376">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ArrowRightIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1051)">
      <path
        d="M12.12 20.88C11.9 20.88 11.67 20.79 11.5 20.62C11.16 20.28 11.16 19.72 11.5 19.38L18.01 12.87H3.88C3.4 12.87 3 12.48 3 11.99C3 11.5 3.39 11.11 3.88 11.11H18.02L11.51 4.6C11.17 4.26 11.17 3.7 11.51 3.36C11.85 3.02 12.41 3.02 12.75 3.36L20.75 11.36C20.83 11.44 20.9 11.54 20.94 11.65C20.98 11.75 21 11.85 21.01 11.96V11.99C21.01 12.1 20.98 12.21 20.94 12.3C20.9 12.41 20.83 12.5 20.75 12.59L12.75 20.59C12.58 20.76 12.35 20.85 12.13 20.85L12.12 20.88Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1051">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ChevronLeftIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3862_20527)">
      <path
        d="M16.8776 4.0025C16.8776 4.2225 16.7976 4.4525 16.6176 4.6225L9.23756 12.0025L16.6176 19.3825C16.9576 19.7225 16.9576 20.2825 16.6176 20.6225C16.2776 20.9625 15.7176 20.9625 15.3776 20.6225L7.37756 12.6225C7.03756 12.2825 7.03756 11.7225 7.37756 11.3825L15.3776 3.3825C15.7176 3.0425 16.2776 3.0425 16.6176 3.3825C16.7876 3.5525 16.8776 3.7825 16.8776 4.0025Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3862_20527">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ChevronRightIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3862_20530)">
      <path
        d="M7.12256 20.0025C7.12256 19.7825 7.20256 19.5525 7.38256 19.3825L14.7626 12.0025L7.38256 4.6225C7.04256 4.2825 7.04256 3.7225 7.38256 3.3825C7.72256 3.0425 8.28256 3.0425 8.62256 3.3825L16.6226 11.3825C16.9626 11.7225 16.9626 12.2825 16.6226 12.6225L8.62256 20.6225C8.28256 20.9625 7.72256 20.9625 7.38256 20.6225C7.21256 20.4525 7.12256 20.2225 7.12256 20.0025Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3862_20530">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ChevronUpIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3246_326621)">
      <path
        d="M20 16.88C19.78 16.88 19.55 16.8 19.38 16.62L12 9.24L4.62 16.62C4.28 16.96 3.72 16.96 3.38 16.62C3.04 16.28 3.04 15.72 3.38 15.38L11.38 7.38C11.72 7.04 12.28 7.04 12.62 7.38L20.62 15.38C20.96 15.72 20.96 16.28 20.62 16.62C20.45 16.79 20.22 16.88 20 16.88Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3246_326621">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const ChevronDownIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3499_351485)">
      <path
        d="M4 7.12489C4.22 7.12489 4.45 7.20488 4.62 7.38488L12 14.7649L19.38 7.38488C19.72 7.04488 20.28 7.04488 20.62 7.38488C20.96 7.72488 20.96 8.28488 20.62 8.62488L12.62 16.6249C12.28 16.9649 11.72 16.9649 11.38 16.6249L3.38 8.62488C3.04 8.28488 3.04 7.72488 3.38 7.38488C3.55 7.21488 3.78 7.12489 4 7.12489Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3499_351485">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const LaunchIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 14 15"
    fill="none"
  >
    <g clip-path="url(#clip0_10555_6487)">
      <path
        d="M7.92136 13.3333H6.08386C5.80386 13.3333 5.57053 13.1058 5.57053 12.82C5.57053 12.5342 5.79803 12.3067 6.08386 12.3067H7.92136C8.20136 12.3067 8.43469 12.5342 8.43469 12.82C8.43469 13.1058 8.20719 13.3333 7.92136 13.3333Z"
        fill="currentColor"
      />
      <path
        d="M11.6197 7.79166L10.2372 6.86416C10.2372 6.77666 10.2372 6.72416 10.2372 6.72416C10.1905 6.08833 10.0447 5.45833 9.80553 4.86333C9.15219 3.22416 7.97969 2.19749 7.50719 1.82999C7.36719 1.71916 7.19219 1.66083 7.01136 1.66083C6.83053 1.66083 6.65553 1.71916 6.51553 1.82999C6.04303 2.19749 4.87053 3.22416 4.21719 4.86333C3.97803 5.45833 3.83219 6.08249 3.77969 6.72416C3.77969 6.72416 3.77969 6.77666 3.77969 6.86416L2.39719 7.79166C2.13469 7.95499 2.01219 8.21749 2.07636 8.47416L2.57219 11.9158C2.65969 12.2717 3.06219 12.505 3.49386 12.505C3.63969 12.505 3.79136 12.4758 3.93136 12.4233L5.72802 11.3967C5.72802 11.3967 5.75136 11.4025 5.75719 11.4025H8.27719C8.27719 11.4025 8.30053 11.3967 8.30636 11.3967L10.103 12.4233C10.243 12.4817 10.3947 12.505 10.5405 12.505C10.9722 12.505 11.3747 12.2717 11.4622 11.9158L11.958 8.47416C12.0164 8.21749 11.8939 7.96083 11.6372 7.79166H11.6197ZM3.52303 11.4608L3.10303 8.53833L3.87302 8.01916C4.00136 8.7425 4.29302 9.6875 4.92302 10.6617L3.52303 11.4608ZM6.41636 6.32749C6.41636 6.00666 6.67886 5.74416 6.99969 5.74416C7.32053 5.74416 7.58303 6.00666 7.58303 6.32749C7.58303 6.64833 7.32053 6.91083 6.99969 6.91083C6.67886 6.91083 6.41636 6.64833 6.41636 6.32749ZM10.4764 11.4608L9.07636 10.6617C9.70053 9.69333 9.99219 8.7425 10.1264 8.01916L10.8964 8.53833L10.4764 11.4608Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10555_6487">
        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
`;
export const ShareIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_960)">
      <path
        d="M19 16C18.14 16 17.38 16.36 16.83 16.94L7.95 12.5C7.98 12.34 8 12.17 8 12C8 11.83 7.98 11.67 7.95 11.5L16.83 7.06C17.38 7.63 18.14 8 19 8C20.66 8 22 6.66 22 5C22 3.34 20.66 2 19 2C17.34 2 16 3.34 16 5C16 5.17 16.02 5.33 16.05 5.5L7.17 9.94C6.62 9.37 5.86 9 5 9C3.34 9 2 10.34 2 12C2 13.66 3.34 15 5 15C5.86 15 6.62 14.64 7.17 14.06L16.05 18.5C16.02 18.66 16 18.83 16 19C16 20.66 17.34 22 19 22C20.66 22 22 20.66 22 19C22 17.34 20.66 16 19 16Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_960">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const MenuIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_132_1033)">
      <path
        d="M2.88956 5.88C2.3998 5.88 2 5.49 2 5C2 4.51 2.3998 4.12 2.88956 4.12H21.1104C21.6002 4.12 22 4.51 22 5C22 5.49 21.6002 5.88 21.1104 5.88H2.88956Z"
        fill="currentColor"
      />
      <path
        d="M2.88956 12.88C2.3998 12.88 2 12.49 2 12C2 11.51 2.3998 11.12 2.88956 11.12H21.1104C21.6002 11.12 22 11.51 22 12C22 12.49 21.6002 12.88 21.1104 12.88H2.88956Z"
        fill="currentColor"
      />
      <path
        d="M2.88956 19.88C2.3998 19.88 2 19.49 2 19C2 18.51 2.3998 18.12 2.88956 18.12H21.1104C21.6002 18.12 22 18.51 22 19C22 19.49 21.6002 19.88 21.1104 19.88H2.88956Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1033">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const MinusIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_140_59)">
      <path
        d="M21.0001 12.88H3.00012C2.52012 12.88 2.12012 12.49 2.12012 12C2.12012 11.51 2.51012 11.12 3.00012 11.12H21.0001C21.4801 11.12 21.8801 11.51 21.8801 12C21.8801 12.49 21.4901 12.88 21.0001 12.88Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_140_59">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const InfoIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_747_45584)">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.25 16.88C13.25 17.57 12.69 18.13 12 18.13C11.31 18.13 10.75 17.57 10.75 16.88V11.63C10.75 10.94 11.31 10.38 12 10.38C12.69 10.38 13.25 10.94 13.25 11.63V16.88ZM12 8.38C11.31 8.38 10.75 7.82 10.75 7.13C10.75 6.44 11.31 5.88 12 5.88C12.69 5.88 13.25 6.44 13.25 7.13C13.25 7.82 12.69 8.38 12 8.38Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_747_45584">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorAddIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_802_122317)">
      <path
        d="M17.2807 9.28871H10.6873V2.7033C10.6873 2.31968 10.3756 2 9.98402 2C9.59241 2 9.28072 2.31169 9.28072 2.7033V9.2967H2.7033C2.31968 9.2967 2 9.60839 2 10C2 10.3916 2.31169 10.7033 2.7033 10.7033H9.2967V17.2967C9.2967 17.6803 9.60839 18 10 18C10.3916 18 10.7033 17.6883 10.7033 17.2967V10.7033H17.2967C17.6803 10.7033 18 10.3916 18 10C18 9.60839 17.6883 9.2967 17.2967 9.2967L17.2807 9.28871Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_802_122317">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const EditorExitIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_3657_203628)">
      <path
        d="M10.9087 10.0018L16.3107 4.59236C16.5631 4.33958 16.5631 3.93514 16.3107 3.68958C16.0583 3.43681 15.6544 3.43681 15.4019 3.68958L10 9.09181L4.59806 3.68958C4.34563 3.43681 3.94175 3.43681 3.68932 3.68958C3.43689 3.94236 3.43689 4.34681 3.68932 4.59236L9.09126 10.0018L3.68932 15.4113C3.43689 15.664 3.43689 16.0685 3.68932 16.314C3.81193 16.4368 3.97781 16.5018 4.14369 16.5018C4.30957 16.5018 4.46824 16.4368 4.59806 16.314L10 10.9118L15.4019 16.314C15.5246 16.4368 15.6904 16.5018 15.8563 16.5018C16.0222 16.5018 16.1809 16.4368 16.3107 16.314C16.5631 16.0613 16.5631 15.6568 16.3107 15.4113L10.9087 10.0018Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3657_203628">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const WikiRemoveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6668 2.3334L9.9735 1.56673C9.84684 1.42006 9.62017 1.3334 9.38017 1.3334H6.62684C6.38684 1.3334 6.16017 1.42006 6.0335 1.56673L5.34017 2.3334H2.6735C2.30684 2.3334 2.00684 2.6334 2.00684 3.00006C2.00684 3.36673 2.30684 3.66673 2.6735 3.66673H13.3402C13.7068 3.66673 14.0068 3.36673 14.0068 3.00006C14.0068 2.6334 13.7068 2.3334 13.3402 2.3334H10.6668Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.00017 13.9334C4.00017 14.3401 4.32684 14.6667 4.72684 14.6667H11.2668C11.6668 14.6667 11.9935 14.3401 11.9935 13.9334L12.7202 4.94673H3.2735L4.00017 13.9334ZM8.9335 7.60006C8.9335 7.28006 9.1935 7.0134 9.52017 7.0134C9.84684 7.0134 10.1068 7.2734 10.1068 7.60006V12.4334C10.1068 12.7534 9.84684 13.0201 9.52017 13.0201C9.1935 13.0201 8.9335 12.7601 8.9335 12.4334V7.60006ZM5.90017 7.60006C5.90017 7.28006 6.16017 7.0134 6.48684 7.0134C6.8135 7.0134 7.0735 7.2734 7.0735 7.60006V12.4334C7.0735 12.7534 6.8135 13.0201 6.48684 13.0201C6.16017 13.0201 5.90017 12.7601 5.90017 12.4334V7.60006Z"
      fill="currentColor"
    />
  </svg>
`;
export const TriangleUpIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 6 6"
    fill="none"
  >
    <path d="M3 0.5L0 5.5H6L3 0.5Z" fill="#D92A0F" />
  </svg>
`;
export const TriangleDownIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 6 6"
    fill="none"
  >
    <path d="M3 5.5L6 0.5L0 0.5L3 5.5Z" fill="#1C75FF" />
  </svg>
`;
export const BlinkIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
    fill="none"
  >
    <g clip-path="url(#clip0_8839_5972)">
      <path
        d="M16.859 11.0835C13.884 9.71852 11.5273 6.70852 10.454 2.91686C10.2323 2.14686 9.41565 2.14686 9.19398 2.91686C8.12065 6.70852 5.76398 9.71852 2.78898 11.0835C2.18232 11.3635 2.18232 12.4135 2.78898 12.6935C5.76398 14.0585 8.12065 17.0685 9.19398 20.8602C9.41565 21.6302 10.2323 21.6302 10.454 20.8602C11.5273 17.0685 13.884 14.0585 16.859 12.6935C17.4657 12.4135 17.4657 11.3635 16.859 11.0835Z"
        fill="#1C75FF"
      />
      <path
        d="M25.4107 19.7402C23.7073 18.9585 22.3657 17.2319 21.7473 15.0735C21.619 14.6302 21.1523 14.6302 21.024 15.0735C20.4057 17.2435 19.064 18.9585 17.3607 19.7402C17.0107 19.9035 17.0107 20.4985 17.3607 20.6619C19.064 21.4435 20.4057 23.1702 21.024 25.3285C21.1523 25.7719 21.619 25.7719 21.7473 25.3285C22.3657 23.1585 23.7073 21.4435 25.4107 20.6619C25.7607 20.4985 25.7607 19.9035 25.4107 19.7402Z"
        fill="#1C75FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_8839_5972">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;
export const CrossIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 80 80"
    fill="none"
  >
    <rect x="30.833" width="18.3333" height="80" fill="currentColor" />
    <rect y="30.8333" width="80" height="18.3333" fill="currentColor" />
  </svg>
`;
export const MShopDefaultIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => {
  return html`
    <svg
      class="${klass}"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_705_98856)">
        <path
          d="M21.54 6.25C20.7 4.18 18.8 2.89 16.57 2.89C14.69 2.89 12.95 3.84 12 5.39C11.05 3.84 9.31002 2.89 7.43002 2.89C5.21002 2.89 3.30002 4.18 2.46002 6.25C1.90002 7.63 1.85002 9.12 2.32002 10.8C2.46002 11.3 2.64002 11.81 2.87002 12.3C3.12002 12.85 3.42002 13.39 3.78002 13.93L3.82002 13.98C4.03002 14.29 4.25002 14.59 4.48002 14.88C6.33002 17.22 8.71002 19.23 11.77 21.05C11.83 21.09 11.91 21.11 12 21.11C12.05 21.11 12.15 21.11 12.23 21.05C15.29 19.24 17.68 17.22 19.52 14.88C19.75 14.59 19.97 14.29 20.18 13.98L20.22 13.91C20.57 13.38 20.88 12.84 21.12 12.29C21.35 11.8 21.53 11.29 21.67 10.79C22.14 9.11 22.09 7.62 21.53 6.24L21.54 6.25ZM16.37 15.78C15.94 16.2 15.48 16.61 15 17C15.18 16.66 15.35 16.31 15.52 15.96C15.81 15.91 16.09 15.85 16.37 15.78ZM14.31 14.39C12.81 14.58 11.2 14.58 9.70002 14.39C9.24002 13.26 8.93002 12.14 8.76002 10.97V10.95C10.85 11.26 13.16 11.26 15.25 10.95V10.97C15.08 12.14 14.77 13.26 14.31 14.39ZM8.48002 15.96C8.64002 16.31 8.82002 16.66 9.00002 17C8.52002 16.6 8.06002 16.19 7.63002 15.78C7.91002 15.85 8.19002 15.91 8.48002 15.96ZM14.27 5.43C14.38 5.46 14.89 5.88 15.19 7.31C15.32 7.9 15.38 8.52 15.38 9.18C13.26 9.54 10.74 9.54 8.62002 9.18C8.62002 8.51 8.68002 7.9 8.81002 7.31C9.11002 5.88 9.62002 5.46 9.70002 5.43C9.79002 5.45 10.21 5.76 10.51 6.79L10.58 7C10.77 7.63 11.35 8.05 12.01 8.05C12.67 8.05 13.24 7.63 13.44 7L13.51 6.79C13.81 5.77 14.24 5.45 14.29 5.43H14.27ZM7.10002 6.94C6.98002 7.52 6.90002 8.14 6.88002 8.78C6.59002 8.69 6.32002 8.6 6.07002 8.51C4.95002 8.08 4.18002 7.52 4.06002 7.04C4.05002 7 4.06002 6.95 4.07002 6.9C4.37002 6.16 4.84002 5.58 5.46002 5.19C6.20002 4.72 7.13002 4.54 8.02002 4.68C7.61002 5.24 7.29002 6.01 7.09002 6.94H7.10002ZM6.95002 10.6C6.97002 10.81 7.00002 11.01 7.03002 11.22C7.17002 12.17 7.39002 13.09 7.69002 14C7.24002 13.88 6.82002 13.74 6.43002 13.57C5.61002 13.23 4.94002 12.59 4.55002 11.78L4.52002 11.72C4.49002 11.61 4.45002 11.51 4.40002 11.45C4.24002 11.08 4.10002 10.7 4.00002 10.33C3.90002 9.97 3.83002 9.62 3.79002 9.29C4.57002 9.83 5.65002 10.28 6.96002 10.6H6.95002ZM16.97 11.22C17 11.01 17.03 10.81 17.05 10.6C18.35 10.27 19.44 9.82 20.22 9.29C20.18 9.63 20.11 9.98 20.01 10.33C19.91 10.7 19.77 11.08 19.63 11.42C19.56 11.52 19.51 11.62 19.5 11.7L19.46 11.78C19.06 12.59 18.4 13.23 17.56 13.58C17.18 13.74 16.76 13.88 16.31 14C16.62 13.08 16.83 12.17 16.97 11.22ZM20.16 6.81L19.93 6.9C19.93 6.9 19.95 7 19.94 7.04C19.82 7.51 19.05 8.08 17.93 8.51C17.68 8.61 17.41 8.7 17.12 8.78C17.1 8.14 17.03 7.52 16.9 6.94C16.7 6.01 16.38 5.23 15.97 4.67C16.86 4.53 17.79 4.71 18.53 5.18C19.15 5.58 19.62 6.15 19.92 6.89L20.15 6.8L20.16 6.81ZM12 18.53C11.47 17.8 10.99 17.04 10.55 16.22C11.52 16.29 12.48 16.29 13.44 16.22C13 17.04 12.53 17.8 11.99 18.53H12Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_705_98856">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `;
};
export const DropdownDownIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.15 17.56C11.56 18.14 12.45 18.14 12.86 17.56L19.83 7.53C20.28 6.88 19.8 6 18.98 6H5.03003C4.21003 6 3.72003 6.88 4.18003 7.53L11.15 17.56Z"
      fill="currentColor"
    />
  </svg>
`;
export const DropdownUpIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.8558 6.435C12.4458 5.855 11.5558 5.855 11.1458 6.435L4.17583 16.465C3.72583 17.115 4.20583 17.995 5.02583 17.995L18.9758 17.995C19.7958 17.995 20.2858 17.115 19.8258 16.465L12.8558 6.435Z"
      fill="currentColor"
    />
  </svg>
`;
export const DotIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html` <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 4 4"
    fill="none"
  >
    <circle cx="2" cy="2" r="2" fill="#1C75FF" />
  </svg>`;
export const SameRankIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 12 3"
    fill="none"
  >
    <rect y="0.799805" width="12" height="2" fill="currentColor" />
  </svg>
`;
export const ShowIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M19.8365 9.68333C19.8068 9.60416 19.1042 7.74374 17.5604 5.88333C15.4922 3.39947 12.8797 2.08333 9.99999 2.08333C7.1203 2.08333 4.5078 3.39947 2.43957 5.88333C0.885927 7.74374 0.183323 9.60416 0.163531 9.68333C0.123948 9.78229 0.104156 9.89114 0.104156 9.99999C0.104156 10.1088 0.123948 10.2177 0.163531 10.3167C0.193219 10.3958 0.895823 12.2562 2.43957 14.1167C4.5078 16.6005 7.1203 17.9068 9.99999 17.9068C12.8797 17.9068 15.4922 16.5906 17.5604 14.1167C19.1141 12.2562 19.8068 10.3958 19.8365 10.3167C19.876 10.2177 19.8958 10.1088 19.8958 9.99999C19.8958 9.89114 19.876 9.78229 19.8365 9.68333ZM9.99999 13.9583C7.81301 13.9583 6.04166 12.187 6.04166 9.99999C6.04166 7.81302 7.81301 6.04166 9.99999 6.04166C12.187 6.04166 13.9583 7.81302 13.9583 9.99999C13.9583 12.187 12.187 13.9583 9.99999 13.9583Z"
      fill="currentColor"
    />
    <path
      d="M9.99999 12.9687C11.6396 12.9687 12.9687 11.6396 12.9687 10C12.9687 8.3604 11.6396 7.03125 9.99999 7.03125C8.3604 7.03125 7.03124 8.3604 7.03124 10C7.03124 11.6396 8.3604 12.9687 9.99999 12.9687Z"
      fill="currentColor"
    />
  </svg>
`;
export const ShowHiddenIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.62704 2.39999C3.29058 2.06354 2.73642 2.06354 2.39996 2.39999C2.0635 2.73645 2.0635 3.29062 2.39996 3.62708L3.51819 4.74531C3.14215 5.09166 2.7859 5.4677 2.43954 5.88333C0.885897 7.74375 0.183293 9.60416 0.163501 9.68333C0.123918 9.78229 0.104126 9.89114 0.104126 10C0.104126 10.1088 0.123918 10.2177 0.163501 10.3167C0.193188 10.3958 0.895793 12.2562 2.43954 14.1167C4.50777 16.6005 7.12027 17.9068 9.99996 17.9068C11.8406 17.9068 13.5625 17.3625 15.1062 16.3234L16.3729 17.5901C16.5411 17.7583 16.7588 17.8474 16.9864 17.8474C17.214 17.8474 17.4317 17.7682 17.6 17.5901C17.9364 17.2536 17.9364 16.6995 17.6 16.363L3.62704 2.39999ZM9.99996 13.9583C7.81298 13.9583 6.04163 12.187 6.04163 10C6.04163 9.21822 6.27913 8.49583 6.66506 7.89218L7.38746 8.61458C7.15985 9.0302 7.03121 9.49531 7.03121 10C7.03121 11.6427 8.35725 12.9687 9.99996 12.9687C10.5046 12.9687 10.9698 12.8401 11.3854 12.6125L12.1078 13.3349C11.4942 13.7208 10.7718 13.9583 9.99996 13.9583Z"
      fill="currentColor"
    />
    <path
      d="M19.8364 9.68333C19.8067 9.60416 19.1041 7.74375 17.5604 5.88333C15.4921 3.39947 12.8796 2.08333 9.99996 2.08333C8.76298 2.08333 7.57548 2.34062 6.45725 2.81562L17.6494 14.0078C19.1338 12.187 19.8067 10.4057 19.8364 10.3266C19.876 10.2276 19.8958 10.1187 19.8958 10.0099C19.8958 9.90104 19.876 9.79218 19.8364 9.69322V9.68333Z"
      fill="currentColor"
    />
  </svg>
`;

export const ShowPrivateIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html`<svg
    class="${klass}"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20618_39832)">
      <path
        d="M4.63366 3.59922C4.35033 3.31589 3.88366 3.31589 3.60033 3.59922C3.31699 3.88255 3.31699 4.34922 3.60033 4.63255L4.98366 6.01589C4.51699 6.34089 4.05866 6.69089 3.63366 7.10755C2.32533 8.41588 1.73366 9.72422 1.71699 9.77422C1.68366 9.84922 1.66699 9.92422 1.66699 9.99922C1.66699 10.0742 1.68366 10.1576 1.71699 10.2242C1.74199 10.2826 2.33366 11.5826 3.63366 12.8909C5.37533 14.6326 7.57533 15.5492 10.0003 15.5492C11.317 15.5492 12.5587 15.2576 13.7003 14.7326L15.3587 16.3909C15.5003 16.5326 15.6837 16.6076 15.8753 16.6076C16.067 16.6076 16.2503 16.5409 16.392 16.3909C16.6753 16.1076 16.6753 15.6409 16.392 15.3576L4.63366 3.59922ZM10.0003 12.7742C9.45033 12.7742 8.91699 12.6076 8.45866 12.3076C8.00033 11.9992 7.64199 11.5659 7.43366 11.0576C7.22533 10.5492 7.16699 9.99089 7.27533 9.44922C7.33366 9.15755 7.44199 8.87422 7.59199 8.61589L11.367 12.3909C10.9503 12.6242 10.4837 12.7659 10.0003 12.7659V12.7742Z"
        fill="white"
      />
      <path
        d="M18.2837 9.77422C18.2587 9.71588 17.667 8.41588 16.367 7.10755C14.6253 5.36589 12.4253 4.44089 10.0003 4.44089C9.24199 4.44089 8.51699 4.54089 7.80866 4.71589L16.1587 13.0659C16.2253 13.0076 16.3003 12.9492 16.3587 12.8909C17.667 11.5826 18.2503 10.2826 18.2753 10.2242C18.3087 10.1576 18.3253 10.0742 18.3253 9.99922C18.3253 9.92422 18.3087 9.84088 18.2753 9.77422H18.2837Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_20618_39832">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg> `;

export const TrashBinIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M12.3203 2.80567H9.69533V2.55484C9.69533 1.79067 9.07116 1.1665 8.30699 1.1665H5.68199C4.91783 1.1665 4.29366 1.79067 4.29366 2.55484V2.80567H1.68033C1.40033 2.80567 1.16699 3.03317 1.16699 3.319C1.16699 3.60484 1.39449 3.83234 1.68033 3.83234H2.61949L3.47116 12.0573C3.51783 12.5007 3.87949 12.839 4.31699 12.839H9.68949C10.1212 12.839 10.4887 12.5007 10.5353 12.0573L11.387 3.83234H12.3262C12.6062 3.83234 12.8395 3.60484 12.8395 3.319C12.8395 3.03317 12.612 2.80567 12.3262 2.80567H12.3203ZM5.32616 2.55484C5.32616 2.3565 5.48949 2.19317 5.68783 2.19317H8.31283C8.51116 2.19317 8.67449 2.3565 8.67449 2.55484V2.80567H5.32033V2.55484H5.32616ZM5.85699 8.2365C5.85699 8.5165 5.62949 8.74984 5.34366 8.74984C5.05783 8.74984 4.83033 8.52234 4.83033 8.2365V5.75734C4.83033 5.47734 5.05783 5.244 5.34366 5.244C5.62949 5.244 5.85699 5.4715 5.85699 5.75734V8.2365ZM9.16449 8.2365C9.16449 8.5165 8.93699 8.74984 8.65116 8.74984C8.36533 8.74984 8.13783 8.52234 8.13783 8.2365V5.75734C8.13783 5.47734 8.36533 5.244 8.65116 5.244C8.93699 5.244 9.16449 5.4715 9.16449 5.75734V8.2365Z"
      fill="currentColor"
    />
  </svg>
`;
export const EditorHandleBarIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.25 2.88C9.08 2.88 9.75 3.55 9.75 4.38C9.75 5.21 9.08 5.88 8.25 5.88C7.42 5.88 6.75 5.21 6.75 4.38C6.75 3.55 7.42 2.88 8.25 2.88Z"
      fill="currentColor"
    />
    <path
      d="M15.75 2.88C16.58 2.88 17.25 3.55 17.25 4.38C17.25 5.21 16.58 5.88 15.75 5.88C14.92 5.88 14.25 5.21 14.25 4.38C14.25 3.55 14.92 2.88 15.75 2.88Z"
      fill="currentColor"
    />
    <path
      d="M8.25 10.5C9.08 10.5 9.75 11.17 9.75 12C9.75 12.83 9.08 13.5 8.25 13.5C7.42 13.5 6.75 12.83 6.75 12C6.75 11.17 7.42 10.5 8.25 10.5Z"
      fill="currentColor"
    />
    <path
      d="M15.75 10.5C16.58 10.5 17.25 11.17 17.25 12C17.25 12.83 16.58 13.5 15.75 13.5C14.92 13.5 14.25 12.83 14.25 12C14.25 11.17 14.92 10.5 15.75 10.5Z"
      fill="currentColor"
    />
    <path
      d="M8.25 18.12C9.08 18.12 9.75 18.79 9.75 19.62C9.75 20.45 9.08 21.12 8.25 21.12C7.42 21.12 6.75 20.45 6.75 19.62C6.75 18.79 7.42 18.12 8.25 18.12Z"
      fill="currentColor"
    />
    <path
      d="M15.75 18.12C16.58 18.12 17.25 18.79 17.25 19.62C17.25 20.45 16.58 21.12 15.75 21.12C14.92 21.12 14.25 20.45 14.25 19.62C14.25 18.79 14.92 18.12 15.75 18.12Z"
      fill="currentColor"
    />
  </svg>
`;
export const ExcelIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_10110_10856)">
      <path
        d="M9.12732 1.33301H3.51398C2.86065 1.33301 2.33398 1.85967 2.33398 2.51301V13.4863C2.33398 14.1397 2.86065 14.6663 3.51398 14.6663H12.4873C13.1407 14.6663 13.6673 14.1397 13.6673 13.4863V5.87301L9.12732 1.33301ZM10.0807 11.5263C10.3073 11.753 10.3073 12.1263 10.0807 12.353C9.96732 12.4663 9.82065 12.5263 9.66732 12.5263C9.51398 12.5263 9.36732 12.473 9.25398 12.353L8.00065 11.0997L6.74732 12.353C6.63398 12.4663 6.48732 12.5263 6.33398 12.5263C6.18065 12.5263 6.03398 12.473 5.92065 12.353C5.69398 12.1263 5.69398 11.753 5.92065 11.5263L7.17398 10.273L5.92065 9.01967C5.69398 8.79301 5.69398 8.41967 5.92065 8.19301C6.14732 7.96634 6.52065 7.96634 6.74732 8.19301L8.00065 9.44634L9.25398 8.19301C9.48065 7.96634 9.85398 7.96634 10.0807 8.19301C10.3073 8.41967 10.3073 8.79301 10.0807 9.01967L8.82732 10.273L10.0807 11.5263ZM9.12732 5.87301V2.97967L12.0207 5.87301H9.12732Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10110_10856">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const CalendarIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_10477_17828)">
      <path
        d="M17.0823 3.54166H14.6073V2.39166C14.6073 1.99166 14.2823 1.65833 13.874 1.65833C13.4656 1.65833 13.1406 1.98333 13.1406 2.39166V3.54166H6.83229V2.39166C6.83229 1.99166 6.50729 1.65833 6.09896 1.65833C5.69063 1.65833 5.36563 1.98333 5.36563 2.39166V3.54166H2.89062C2.19896 3.54166 1.64062 4.09999 1.64062 4.79166V17.15C1.64062 17.8083 2.19896 18.3333 2.89062 18.3333H17.0573C17.749 18.3333 18.3073 17.8 18.3073 17.15V4.79166C18.3073 4.09999 17.749 3.54166 17.0573 3.54166H17.0823ZM11.874 14.2667H8.12396C7.72396 14.2667 7.39062 13.9417 7.39062 13.5333C7.39062 13.125 7.71562 12.8 8.12396 12.8H11.874C12.274 12.8 12.6073 13.125 12.6073 13.5333C12.6073 13.9417 12.2823 14.2667 11.874 14.2667ZM16.874 8.74999H3.12396V5.41666C3.12396 5.18333 3.30729 4.99999 3.54062 4.99999H5.39062V6.14166C5.39062 6.54166 5.71562 6.87499 6.12396 6.87499C6.53229 6.87499 6.85729 6.54999 6.85729 6.14166V4.99999H13.1656V6.14166C13.1656 6.54166 13.4906 6.87499 13.899 6.87499C14.3073 6.87499 14.6323 6.54999 14.6323 6.14166V4.99999H16.4823C16.7156 4.99999 16.899 5.18333 16.899 5.41666V8.74999H16.874Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10477_17828">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const CheckIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.87277 7.1743C3.53088 6.83241 2.97656 6.83241 2.63467 7.1743C2.29278 7.5162 2.29278 8.07051 2.63467 8.4124L5.98754 11.7653C6.30091 12.0786 6.809 12.0786 7.12237 11.7653L13.3645 5.52316C13.7064 5.18127 13.7064 4.62695 13.3645 4.28506C13.0226 3.94317 12.4683 3.94317 12.1264 4.28506L6.96761 9.44384C6.73971 9.67174 6.3702 9.67174 6.1423 9.44384L3.87277 7.1743Z"
      fill="currentColor"
    />
  </svg>
`;

export const sortInActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.31538 1.389C5.38871 1.41567 5.44871 1.46233 5.50204 1.51567L7.67538 3.689C7.90204 3.91567 7.90204 4.289 7.67538 4.51567C7.44871 4.74233 7.07538 4.74233 6.84871 4.51567L5.67538 3.34233L5.67538 14.089C5.67538 14.409 5.41538 14.6757 5.08871 14.6757C4.76204 14.6757 4.50204 14.4157 4.50204 14.089L4.50204 3.329L3.32871 4.50233C3.10204 4.729 2.72871 4.729 2.50204 4.50233C2.38871 4.389 2.32871 4.24233 2.32871 4.089C2.32871 3.93567 2.38871 3.789 2.50204 3.67567L4.67538 1.50233C4.72871 1.449 4.79538 1.40233 4.86871 1.37567C5.00871 1.31566 5.16871 1.31566 5.31538 1.37567L5.31538 1.389Z"
      fill="currentColor"
    />
    <path
      d="M10.702 14.629C10.6287 14.6023 10.5687 14.5557 10.5087 14.5023L8.33538 12.329C8.22204 12.2157 8.16204 12.069 8.16204 11.9157C8.16204 11.7623 8.22204 11.6157 8.33538 11.5023C8.56204 11.2757 8.93538 11.2757 9.16204 11.5023L10.3354 12.6757L10.3354 1.91567C10.3354 1.59567 10.5954 1.329 10.922 1.329C11.2487 1.329 11.5087 1.589 11.5087 1.91567L11.5087 12.6823L12.682 11.509C12.9087 11.2823 13.282 11.2823 13.5087 11.509C13.7354 11.7357 13.7354 12.109 13.5087 12.3357L11.3354 14.509C11.282 14.5623 11.2154 14.609 11.1487 14.6357C11.0087 14.6957 10.8487 14.6957 10.702 14.6357L10.702 14.629Z"
      fill="currentColor"
    />
  </svg>
`;

export const sortDescActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 16"
    fill="none"
  >
    <g clip-path="url(#clip0_10197_30773)">
      <path
        d="M12.8289 8.97005C12.6011 8.74219 12.2313 8.74219 12.0034 8.97005L8.99951 11.9745V2.58333C8.99951 2.26107 8.73844 2 8.41618 2C8.09391 2 7.83284 2.26107 7.83284 2.58333V11.9745L4.82894 8.97005C4.60107 8.74219 4.23128 8.74219 4.00342 8.97005C3.7762 9.19792 3.7762 9.56771 4.00342 9.79557L8.00342 13.7956C8.01388 13.806 8.02783 13.8096 8.03886 13.8191C8.08557 13.8595 8.13497 13.8971 8.19283 13.9211C8.26432 13.9506 8.34017 13.9662 8.41618 13.9662C8.49218 13.9662 8.56803 13.9506 8.63952 13.9211C8.69738 13.8971 8.74678 13.8595 8.7935 13.8191C8.80452 13.8096 8.81848 13.806 8.82894 13.7956L12.8289 9.79557C13.0562 9.56771 13.0562 9.19792 12.8289 8.97005Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10197_30773">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
`;

export const sortAscActiveIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 16"
    fill="none"
  >
    <g clip-path="url(#clip0_10197_30778)">
      <path
        d="M12.9128 6.17005L8.91276 2.17005C8.90711 2.1644 8.89941 2.16264 8.89355 2.15727C8.84359 2.11109 8.78768 2.07109 8.72387 2.04456C8.58089 1.98515 8.41979 1.98515 8.27681 2.04456C8.21289 2.07113 8.1569 2.11121 8.10685 2.15747C8.10107 2.1628 8.09347 2.16447 8.08789 2.17004L4.08789 6.17004C3.86003 6.39791 3.86003 6.76769 4.08789 6.99556C4.31576 7.22343 4.6849 7.22343 4.91276 6.99556L7.91699 3.99105V13.3823C7.91699 13.7045 8.17806 13.9656 8.50033 13.9656C8.82259 13.9656 9.08366 13.7045 9.08366 13.3823V3.99106L12.0879 6.99557C12.2018 7.1095 12.3509 7.16614 12.5003 7.16614C12.6497 7.16614 12.7988 7.1095 12.9128 6.99557C13.1406 6.7677 13.1406 6.39792 12.9128 6.17005Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10197_30778">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
`;

export const typeFilterIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_10197_27977)">
      <path
        d="M13.4008 2H2.60077C2.12677 2 1.84477 2.516 2.09077 2.918L6.38077 8.774C6.45877 8.876 6.49477 9.002 6.49477 9.128V14L9.49477 12.422V9.128C9.49477 9.002 9.53677 8.876 9.60877 8.774L13.8988 2.918C14.1508 2.516 13.8628 2 13.3888 2H13.4008Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10197_27977">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const receiptIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.97 5.10002C20.91 4.83002 20.78 4.58002 20.59 4.39002C20.53 4.33002 20.46 4.27002 20.38 4.22002C20.16 4.07002 19.89 3.98002 19.6 3.98002H17.84C17.69 2.88002 16.74 2.02002 15.6 2.02002H8.4C7.25 2.02002 6.31 2.88002 6.16 3.98002H4.4C3.63 3.98002 3 4.61002 3 5.38002V20.58C3 21.35 3.63 21.98 4.4 21.98H19.6C20.37 21.98 21 21.35 21 20.58V5.38002C21 5.28002 21 5.19002 20.97 5.10002ZM7.88 4.29002C7.88 4.00002 8.12 3.77002 8.41 3.77002H15.61C15.9 3.77002 16.14 4.01002 16.14 4.29002V5.49002C16.14 5.78002 15.9 6.01002 15.61 6.01002H8.41C8.12 6.01002 7.88 5.77002 7.88 5.49002V4.29002ZM15.63 14.33L11.96 18.13C11.8 18.3 11.57 18.4 11.33 18.4C11.09 18.4 10.87 18.3 10.7 18.13L8.37 15.72C8.03 15.37 8.04 14.82 8.39 14.48C8.74 14.15 9.29 14.15 9.63 14.5L11.33 16.26L14.37 13.11C14.7 12.76 15.26 12.75 15.61 13.09C15.96 13.43 15.97 13.98 15.63 14.33ZM19.25 9.83002C19.25 10.05 19.07 10.23 18.85 10.23H5.15C4.93 10.23 4.75 10.05 4.75 9.83002V6.13002C4.75 6.07002 4.76 6.02002 4.78 5.97002C4.84 5.83002 4.98 5.73002 5.15 5.73002H6.15C6.27 6.87002 7.23 7.77002 8.4 7.77002H15.6C16.77 7.77002 17.73 6.87002 17.85 5.73002H18.85C19.07 5.73002 19.25 5.91002 19.25 6.13002V9.83002Z"
      fill="currentColor"
    />
  </svg>
`;

export const productPreparingIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.89 6.28L12.89 2.21C12.61 2.07 12.31 2 12 2C11.69 2 11.39 2.07 11.11 2.21L3.11 6.28C2.43 6.63 2 7.34 2 8.11V15.89C2 16.67 2.43 17.38 3.11 17.72L11.11 21.78C11.39 21.92 11.69 21.99 12 21.99C12.31 21.99 12.61 21.92 12.89 21.78L20.89 17.72C21.57 17.37 22 16.66 22 15.89V8.11C22 7.33 21.57 6.62 20.89 6.28ZM11.9 3.77C11.9 3.77 11.96 3.75 12 3.75C12.04 3.75 12.07 3.75 12.1 3.77L19.21 7.38L16.63 8.68L9.81 4.83L11.9 3.77ZM4.79 7.39L7.94 5.79L14.75 9.64L12 11.02L4.79 7.39ZM20.25 15.89C20.25 16.01 20.19 16.12 20.1 16.16L12.88 19.83V12.54L15.73 11.1V14.09C15.73 14.57 16.12 14.97 16.61 14.97C17.1 14.97 17.49 14.58 17.49 14.09V10.22L20.26 8.82V15.89H20.25Z"
      fill="currentColor"
    />
  </svg>
`;

export const deliveryIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.84 13.0801L19.21 7.99012C18.97 7.53012 18.49 7.23012 17.97 7.23012H17V4.77012C17 4.00012 16.37 3.37012 15.6 3.37012H3.4C2.63 3.37012 2 4.00012 2 4.77012V15.9701C2 16.7401 2.63 17.3701 3.4 17.3701H3.75C3.75 19.1601 5.21 20.6201 7 20.6201C7.45 20.6201 7.88 20.5301 8.27 20.3601C8.66 20.2001 9.01 19.9601 9.3 19.6601C9.89 19.0701 10.25 18.2601 10.25 17.3601H13.35C13.35 19.1501 14.81 20.6101 16.6 20.6101C17.05 20.6101 17.48 20.5201 17.87 20.3501C18.26 20.1901 18.61 19.9501 18.9 19.6501C19.49 19.0601 19.85 18.2501 19.85 17.3501H20.6C21.37 17.3501 22 16.7201 22 15.9501V13.7001C22 13.4801 21.95 13.2601 21.84 13.0601V13.0801ZM7 18.8801C6.17 18.8801 5.5 18.2101 5.5 17.3801C5.5 16.5501 6.17 15.8801 7 15.8801C7.83 15.8801 8.5 16.5501 8.5 17.3801C8.5 18.2101 7.83 18.8801 7 18.8801ZM14.12 7.15012H4.88C4.4 7.15012 4 6.76012 4 6.27012C4 5.78012 4.39 5.39012 4.88 5.39012H14.13C14.61 5.39012 15.01 5.78012 15.01 6.27012C15.01 6.76012 14.62 7.15012 14.13 7.15012H14.12ZM16.6 18.8801C15.77 18.8801 15.1 18.2101 15.1 17.3801C15.1 16.5501 15.77 15.8801 16.6 15.8801C17.43 15.8801 18.1 16.5501 18.1 17.3801C18.1 18.2101 17.43 18.8801 16.6 18.8801ZM19.15 12.4401H17V8.99012H17.34C17.34 8.99012 17.74 8.96012 17.97 9.41012L19.36 12.1001C19.44 12.2601 19.33 12.4401 19.15 12.4401Z"
      fill="currentColor"
    />
  </svg>
`;

export const deliveryReturnIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.0281 3.37012C16.7981 3.37012 17.4285 4.00051 17.4285 4.77051V7.23047H18.3982C18.9182 7.23047 19.3984 7.53023 19.6384 7.99023L22.2683 13.0801V13.0605C22.3782 13.2605 22.4285 13.4803 22.4285 13.7002V15.9502C22.4284 16.7202 21.798 17.3506 21.0281 17.3506H20.2781C20.278 18.2504 19.9187 19.0605 19.3289 19.6504C19.0389 19.9504 18.6886 20.1906 18.2986 20.3506C17.9086 20.5206 17.478 20.6104 17.0281 20.6104C15.2383 20.6101 13.7782 19.1501 13.7781 17.3604H12.3943C12.075 14.3474 9.52608 12 6.42847 12C4.89163 12 3.49001 12.5781 2.42847 13.5283V4.77051C2.42847 4.00051 3.05886 3.37012 3.82886 3.37012H16.0281ZM17.0281 15.8799C16.1983 15.8801 15.5282 16.5501 15.5281 17.3799C15.5281 18.2098 16.1983 18.8797 17.0281 18.8799C17.8581 18.8799 18.5281 18.2099 18.5281 17.3799C18.528 16.55 17.858 15.8799 17.0281 15.8799ZM17.4285 8.99023V12.4404H19.5789C19.7584 12.4402 19.8683 12.2603 19.7888 12.1006L18.3982 9.41016C18.1682 8.96024 17.7683 8.99023 17.7683 8.99023H17.4285ZM5.30835 5.38965C4.8184 5.38971 4.42847 5.78055 4.42847 6.27051C4.42868 6.76028 4.82853 7.15033 5.30835 7.15039H14.5583C15.0482 7.15039 15.438 6.76032 15.4382 6.27051C15.4382 5.78051 15.0383 5.38965 14.5583 5.38965H5.30835Z"
      fill="currentColor"
    />
    <path
      d="M6.42847 13C9.18989 13 11.4285 15.2386 11.4285 18C11.4285 20.7614 9.18989 23 6.42847 23C3.66704 23 1.42847 20.7614 1.42847 18C1.42847 15.2386 3.66704 13 6.42847 13ZM5.68726 15.1396C5.46522 14.9182 5.12288 14.8905 4.87085 15.0566L4.76831 15.1396L3.56812 16.3398C3.4463 16.4617 3.37775 16.6275 3.37769 16.7998C3.3777 16.9721 3.44638 17.1379 3.56812 17.2598L4.76831 18.459C5.02212 18.7128 5.43342 18.7127 5.68726 18.459C5.90937 18.2368 5.93791 17.8939 5.77124 17.6416L5.68726 17.54L5.59741 17.4502H7.32788C7.79725 17.4502 8.17834 17.8305 8.17847 18.2998C8.17847 18.7692 7.79732 19.1494 7.32788 19.1494H4.62769C4.26907 19.1498 3.97839 19.4411 3.97827 19.7998C3.97827 20.1586 4.26899 20.4499 4.62769 20.4502H7.32788C8.51529 20.4502 9.47827 19.4872 9.47827 18.2998C9.47815 17.1125 8.51522 16.1494 7.32788 16.1494H5.59741L5.68726 16.0596C5.94108 15.8057 5.94112 15.3935 5.68726 15.1396Z"
      fill="currentColor"
    />
  </svg>
`;

export const deliveryCompletedIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.89 6.28L12.89 2.21C12.61 2.07 12.31 2 12 2C11.69 2 11.39 2.07 11.11 2.21L3.11 6.28C2.43 6.63 2 7.34 2 8.11V13.71C2 14.04 2.37 14.22 2.64 14.02C3.79 13.16 5.3 12.77 6.91 13.11C8.85 13.53 10.43 15.09 10.87 17.03C11.19 18.44 10.86 19.74 10.29 20.87C10.1 21.26 10.42 21.42 10.42 21.42L11.12 21.77C11.4 21.91 11.7 21.98 12.01 21.98C12.32 21.98 12.62 21.91 12.9 21.77L20.9 17.71C21.58 17.36 22.01 16.65 22.01 15.88V8.1C22.01 7.32 21.58 6.61 20.9 6.27L20.89 6.28ZM11.9 3.77C11.9 3.77 11.96 3.75 12 3.75C12.04 3.75 12.07 3.75 12.1 3.77L19.21 7.38L16.63 8.68L9.81 4.83L11.9 3.77ZM4.79 7.39L7.94 5.79L14.75 9.64L12 11.02L4.79 7.39ZM20.26 15.89H20.25C20.25 16.01 20.19 16.12 20.1 16.16L12.88 19.83V12.54L15.73 11.1V14.09C15.73 14.57 16.12 14.97 16.61 14.97C17.1 14.97 17.49 14.58 17.49 14.09V10.22L20.26 8.82V15.89Z"
      fill="currentColor"
    />
    <path
      d="M5.75 14.5C3.68 14.5 2 16.18 2 18.25C2 20.32 3.68 22 5.75 22C7.82 22 9.5 20.32 9.5 18.25C9.5 16.18 7.82 14.5 5.75 14.5ZM7.7 17.96L5.85 19.84C5.73 19.96 5.57 20.03 5.4 20.03C5.23 20.03 5.07 19.96 4.95 19.84L3.78 18.65C3.54 18.4 3.54 18.01 3.78 17.77C4.03 17.53 4.42 17.53 4.66 17.77L5.38 18.51L6.78 17.08C7.02 16.83 7.42 16.83 7.66 17.08C7.91 17.32 7.91 17.72 7.66 17.96H7.7Z"
      fill="currentColor"
    />
  </svg>
`;

export const confirmationIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3434_9978)">
      <path
        d="M20.74 9.75C20.4 9.4 20.06 9.04 19.92 8.72C19.8 8.43 19.79 7.94 19.78 7.48C19.77 6.61 19.75 5.62 19.07 4.93C18.39 4.24 17.4 4.23 16.52 4.22C16.05 4.22 15.57 4.21 15.28 4.08C14.96 3.95 14.6 3.6 14.25 3.26C13.63 2.67 12.93 2 12 2C11.07 2 10.37 2.67 9.75 3.26C9.4 3.6 9.04 3.94 8.72 4.08C8.43 4.2 7.94 4.21 7.48 4.22C6.61 4.23 5.62 4.25 4.93 4.93C4.24 5.61 4.23 6.6 4.22 7.48C4.22 7.95 4.21 8.43 4.08 8.72C3.95 9.04 3.6 9.4 3.26 9.75C2.67 10.37 2 11.07 2 12C2 12.93 2.67 13.63 3.26 14.25C3.6 14.6 3.94 14.96 4.08 15.28C4.2 15.57 4.21 16.06 4.22 16.52C4.23 17.39 4.25 18.38 4.93 19.07C5.62 19.76 6.6 19.77 7.48 19.78C7.95 19.78 8.43 19.79 8.72 19.92C9.04 20.05 9.4 20.4 9.75 20.74C10.37 21.33 11.07 22 12 22C12.93 22 13.63 21.33 14.25 20.74C14.6 20.4 14.96 20.06 15.28 19.92C15.57 19.8 16.06 19.79 16.52 19.78C17.39 19.77 18.38 19.75 19.07 19.07C19.76 18.38 19.77 17.4 19.78 16.52C19.78 16.05 19.79 15.57 19.92 15.28C20.05 14.96 20.4 14.6 20.74 14.25C21.33 13.63 22 12.93 22 12C22 11.07 21.33 10.37 20.74 9.75ZM16.74 10.09L11.77 15.29C11.58 15.49 11.32 15.6 11.05 15.6C10.78 15.6 10.52 15.49 10.33 15.29L7.26 12.08C6.88 11.68 6.89 11.05 7.29 10.67C7.69 10.29 8.32 10.3 8.7 10.7L11.05 13.15L15.3 8.71C15.68 8.31 16.32 8.3 16.71 8.68C17.11 9.06 17.12 9.69 16.74 10.09Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3434_9978">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const smallXIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 7 8"
    fill="none"
  >
    <rect
      x="0.332031"
      y="1.62939"
      width="1.3"
      height="8"
      rx="0.65"
      transform="rotate(-45 0.332031 1.62939)"
      fill="currentColor"
    />
    <rect
      x="0.332031"
      y="6.36719"
      width="8"
      height="1.3"
      rx="0.65"
      transform="rotate(-45 0.332031 6.36719)"
      fill="currentColor"
    />
  </svg>
`;

export const smallReturnIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 11 10"
    fill="none"
  >
    <path
      d="M2.62109 7.35C2.26211 7.35 1.97109 7.64102 1.97109 8C1.97109 8.35898 2.26211 8.65 2.62109 8.65V7.35ZM1.62109 3.65H7.12109V2.35H1.62109V3.65ZM7.12109 7.35H2.62109V8.65H7.12109V7.35ZM8.97109 5.5C8.97109 6.52173 8.14282 7.35 7.12109 7.35V8.65C8.86079 8.65 10.2711 7.2397 10.2711 5.5H8.97109ZM7.12109 3.65C8.14282 3.65 8.97109 4.47827 8.97109 5.5H10.2711C10.2711 3.7603 8.86079 2.35 7.12109 2.35V3.65Z"
      fill="currentColor"
    />
    <path
      d="M3.62109 1L1.62109 3L3.62109 5"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

export const returnIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g clip-path="url(#clip0_12603_12808)">
      <path
        d="M12.878 6.17074H4.59466L6.36966 4.39574C6.653 4.1124 6.653 3.64574 6.36966 3.3624C6.08633 3.07907 5.61966 3.07907 5.33633 3.3624L2.38633 6.3124C2.06133 6.6374 2.06133 7.1624 2.38633 7.4874L5.33633 10.4374C5.61966 10.7207 6.08633 10.7207 6.36966 10.4374C6.653 10.1541 6.653 9.6874 6.36966 9.40407L4.59466 7.62907H12.878C15.3447 7.62907 17.3613 9.6374 17.3613 12.1124C17.3613 14.5874 15.353 16.5957 12.878 16.5957H6.34466C5.94466 16.5957 5.61133 16.9207 5.61133 17.3291C5.61133 17.7374 5.93633 18.0624 6.34466 18.0624H12.878C16.153 18.0624 18.8113 15.3957 18.8113 12.1291C18.8113 8.8624 16.1447 6.19574 12.878 6.19574V6.17074Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_12603_12808">
        <rect width="20" height="20" fill="white" transform="translate(0.478516 0.595703)" />
      </clipPath>
    </defs>
  </svg>
`;

export const returnPlusIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.4243 21 10.8613 20.946 10.3157 20.8427C10.7512 20.0777 11 19.1928 11 18.25C11 17.3042 10.7496 16.4167 10.3116 15.6501H13.4996C15.2393 15.6501 16.6496 14.2398 16.6496 12.5001C16.6496 10.7604 15.2393 9.3501 13.4996 9.3501H9.56885L10.4592 8.45972C10.7131 8.20588 10.7131 7.79432 10.4592 7.54048C10.2054 7.28664 9.79383 7.28664 9.53999 7.54048L7.53999 9.54048C7.28615 9.79432 7.28615 10.2059 7.53999 10.4597L9.53999 12.4597C9.79383 12.7136 10.2054 12.7136 10.4592 12.4597C10.7131 12.2059 10.7131 11.7943 10.4592 11.5405L9.56885 10.6501H13.4996C14.5213 10.6501 15.3496 11.4784 15.3496 12.5001C15.3496 13.5218 14.5213 14.3501 13.4996 14.3501H9.26395C8.33332 13.511 7.10107 13 5.75 13C4.80722 13 3.92229 13.2488 3.15734 13.6843C3.05405 13.1387 3 12.5757 3 12Z"
      fill="currentColor"
    />
    <path
      d="M5.75 14.5C7.82 14.5 9.5 16.18 9.5 18.25C9.5 20.32 7.82 22 5.75 22C3.68 22 2 20.32 2 18.25C2 16.18 3.68 14.5 5.75 14.5ZM5.75 15.6641C5.39108 15.6641 5.10059 15.9555 5.10059 16.3145V17.5996H3.81445C3.45553 17.5997 3.16506 17.8911 3.16504 18.25C3.16504 18.6089 3.45552 18.9003 3.81445 18.9004H5.10059V20.1855C5.10059 20.5445 5.39108 20.8359 5.75 20.8359C6.10898 20.8359 6.40039 20.5445 6.40039 20.1855V18.9004H7.68652C8.04534 18.9002 8.33594 18.6089 8.33594 18.25C8.33592 17.8912 8.04533 17.5998 7.68652 17.5996H6.40039V16.3145C6.40039 15.9555 6.10898 15.6641 5.75 15.6641Z"
      fill="currentColor"
    />
  </svg>
`;

export const returnCompleteIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.66699 12C3.66699 7.02944 7.69643 3 12.667 3C17.6376 3 21.667 7.02944 21.667 12C21.667 16.9706 17.6376 21 12.667 21C12.0913 21 11.5283 20.946 10.9827 20.8427C11.4182 20.0777 11.667 19.1928 11.667 18.25C11.667 17.3042 11.4166 16.4167 10.9786 15.6501H14.1666C15.9063 15.6501 17.3166 14.2398 17.3166 12.5001C17.3166 10.7604 15.9063 9.3501 14.1666 9.3501H10.2358L11.1262 8.45972C11.3801 8.20588 11.3801 7.79432 11.1262 7.54048C10.8724 7.28664 10.4608 7.28664 10.207 7.54048L8.20698 9.54048C7.95314 9.79432 7.95314 10.2059 8.20698 10.4597L10.207 12.4597C10.4608 12.7136 10.8724 12.7136 11.1262 12.4597C11.3801 12.2059 11.3801 11.7943 11.1262 11.5405L10.2358 10.6501H14.1666C15.1883 10.6501 16.0166 11.4784 16.0166 12.5001C16.0166 13.5218 15.1883 14.3501 14.1666 14.3501H9.93094C9.00031 13.511 7.76806 13 6.41699 13C5.47421 13 4.58929 13.2488 3.82433 13.6843C3.72104 13.1387 3.66699 12.5757 3.66699 12Z"
      fill="currentColor"
    />
    <path
      d="M6.41699 14.5C4.34699 14.5 2.66699 16.18 2.66699 18.25C2.66699 20.32 4.34699 22 6.41699 22C8.48699 22 10.167 20.32 10.167 18.25C10.167 16.18 8.48699 14.5 6.41699 14.5ZM8.36699 17.96L6.51699 19.84C6.39699 19.96 6.23699 20.03 6.06699 20.03C5.89699 20.03 5.73699 19.96 5.61699 19.84L4.44699 18.65C4.20699 18.4 4.20699 18.01 4.44699 17.77C4.69699 17.53 5.08699 17.53 5.32699 17.77L6.04699 18.51L7.44699 17.08C7.68699 16.83 8.08699 16.83 8.32699 17.08C8.57699 17.32 8.57699 17.72 8.32699 17.96H8.36699Z"
      fill="currentColor"
    />
  </svg>
`;

export const returnRejectIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.33398 12C3.33398 7.02944 7.36342 3 12.334 3C17.3045 3 21.334 7.02944 21.334 12C21.334 16.9706 17.3045 21 12.334 21C11.7583 21 11.1953 20.946 10.6497 20.8427C11.0852 20.0777 11.334 19.1928 11.334 18.25C11.334 17.3042 11.0836 16.4167 10.6456 15.6501H13.8336C15.5733 15.6501 16.9836 14.2398 16.9836 12.5001C16.9836 10.7604 15.5733 9.3501 13.8336 9.3501H9.90283L10.7932 8.45972C11.0471 8.20588 11.0471 7.79432 10.7932 7.54048C10.5394 7.28664 10.1278 7.28664 9.87397 7.54048L7.87397 9.54048C7.62013 9.79432 7.62013 10.2059 7.87397 10.4597L9.87397 12.4597C10.1278 12.7136 10.5394 12.7136 10.7932 12.4597C11.0471 12.2059 11.0471 11.7943 10.7932 11.5405L9.90283 10.6501H13.8336C14.8553 10.6501 15.6836 11.4784 15.6836 12.5001C15.6836 13.5218 14.8553 14.3501 13.8336 14.3501H9.59793C8.6673 13.511 7.43505 13 6.08398 13C5.1412 13 4.25628 13.2488 3.49132 13.6843C3.38803 13.1387 3.33398 12.5757 3.33398 12Z"
      fill="currentColor"
    />
    <path
      d="M6.08398 14.5C8.15398 14.5 9.83398 16.18 9.83398 18.25C9.83398 20.32 8.15398 22 6.08398 22C4.01398 22 2.33398 20.32 2.33398 18.25C2.33398 16.18 4.01398 14.5 6.08398 14.5ZM7.91309 16.4209C7.65927 16.1671 7.24701 16.1671 6.99316 16.4209L6.08398 17.3311L5.1748 16.4219C4.92096 16.168 4.5097 16.168 4.25586 16.4219C4.00211 16.6757 4.00206 17.087 4.25586 17.3408L5.16504 18.25L4.25586 19.1592C4.00211 19.413 4.00206 19.8243 4.25586 20.0781C4.50967 20.3319 4.92096 20.3319 5.1748 20.0781L6.08398 19.1689L6.99316 20.0781C7.247 20.332 7.65925 20.332 7.91309 20.0781C8.16647 19.8243 8.16663 19.4129 7.91309 19.1592L7.00293 18.25L7.91309 17.3408C8.16684 17.087 8.1669 16.6747 7.91309 16.4209Z"
      fill="currentColor"
    />
  </svg>
`;

export const wrinkledAcceptIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_294_2150)">
      <path
        d="M20.74 9.75C20.4 9.4 20.06 9.04 19.92 8.72C19.8 8.43 19.79 7.94 19.78 7.48C19.77 6.61 19.75 5.62 19.07 4.93C18.39 4.24 17.4 4.23 16.52 4.22C16.05 4.22 15.57 4.21 15.28 4.08C14.96 3.95 14.6 3.6 14.25 3.26C13.63 2.67 12.93 2 12 2C11.07 2 10.37 2.67 9.75 3.26C9.4 3.6 9.04 3.94 8.72 4.08C8.43 4.2 7.94 4.21 7.48 4.22C6.61 4.23 5.62 4.25 4.93 4.93C4.24 5.61 4.23 6.6 4.22 7.48C4.22 7.95 4.21 8.43 4.08 8.72C3.95 9.04 3.6 9.4 3.26 9.75C2.67 10.37 2 11.07 2 12C2 12.93 2.67 13.63 3.26 14.25C3.6 14.6 3.94 14.96 4.08 15.28C4.2 15.57 4.21 16.06 4.22 16.52C4.23 17.39 4.25 18.38 4.93 19.07C5.62 19.76 6.6 19.77 7.48 19.78C7.95 19.78 8.43 19.79 8.72 19.92C9.04 20.05 9.4 20.4 9.75 20.74C10.37 21.33 11.07 22 12 22C12.93 22 13.63 21.33 14.25 20.74C14.6 20.4 14.96 20.06 15.28 19.92C15.57 19.8 16.06 19.79 16.52 19.78C17.39 19.77 18.38 19.75 19.07 19.07C19.76 18.38 19.77 17.4 19.78 16.52C19.78 16.05 19.79 15.57 19.92 15.28C20.05 14.96 20.4 14.6 20.74 14.25C21.33 13.63 22 12.93 22 12C22 11.07 21.33 10.37 20.74 9.75ZM16.74 10.09L11.77 15.29C11.58 15.49 11.32 15.6 11.05 15.6C10.78 15.6 10.52 15.49 10.33 15.29L7.26 12.08C6.88 11.68 6.89 11.05 7.29 10.67C7.69 10.29 8.32 10.3 8.7 10.7L11.05 13.15L15.3 8.71C15.68 8.31 16.32 8.3 16.71 8.68C17.11 9.06 17.12 9.69 16.74 10.09Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_294_2150">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const checkCircleIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html`<svg
    class="${klass}"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.74 10.09L11.77 15.29C11.58 15.49 11.32 15.6 11.05 15.6C10.78 15.6 10.52 15.49 10.33 15.29L7.26 12.08C6.88 11.68 6.89 11.05 7.29 10.67C7.69 10.29 8.32 10.3 8.7 10.7L11.05 13.15L15.3 8.71C15.68 8.31 16.32 8.3 16.71 8.68C17.11 9.06 17.12 9.69 16.74 10.09Z"
      fill="currentColor"
    />
  </svg> `;

export const warningTriangleIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html`<svg
    class="${klass}"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20540_166353)">
      <path
        d="M21.7508 17.8097L13.3008 4.46969C12.6908 3.49969 11.3008 3.49969 10.6808 4.46969L2.25081 17.8197C1.59081 18.8697 2.33081 20.2497 3.56081 20.2497H20.4408C21.6708 20.2497 22.4108 18.8697 21.7508 17.8097ZM12.0008 17.9197C11.5208 17.9197 11.1208 17.5297 11.1208 17.0397C11.1208 16.5497 11.5108 16.1597 12.0008 16.1597C12.4908 16.1597 12.8808 16.5497 12.8808 17.0397C12.8808 17.5297 12.4908 17.9197 12.0008 17.9197ZM12.8808 13.8297C12.8808 14.3097 12.4908 14.7097 12.0008 14.7097C11.5108 14.7097 11.1208 14.3197 11.1208 13.8297V9.33969C11.1208 8.85969 11.5108 8.45969 12.0008 8.45969C12.4908 8.45969 12.8808 8.84969 12.8808 9.33969V13.8297Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_20540_166353">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg> `;

export const refundAcceptedIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M9.20289 16.2791C8.97789 16.2791 8.75289 16.1874 8.60289 16.0207L2.87789 10.0374C2.56123 9.70405 2.56956 9.17905 2.90289 8.85405C3.23623 8.53738 3.76123 8.54572 4.08623 8.87905L9.20289 14.2374L17.8696 5.17072C18.1862 4.83738 18.7196 4.82905 19.0529 5.14572C19.3862 5.46238 19.3946 5.99572 19.0779 6.32905L9.80289 16.0291C9.64456 16.1957 9.42789 16.2874 9.20289 16.2874V16.2791Z"
      fill="currentColor"
    />
  </svg>
`;

export const refundXIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M11.5271 10.5958L17.7601 4.35417C18.0513 4.0625 18.0513 3.59583 17.7601 3.3125C17.4688 3.02083 17.0028 3.02083 16.7115 3.3125L10.4785 9.54583L4.24551 3.3125C3.95424 3.02083 3.48822 3.02083 3.19696 3.3125C2.9057 3.60417 2.9057 4.07083 3.19696 4.35417L9.42997 10.5958L3.19696 16.8375C2.9057 17.1292 2.9057 17.5958 3.19696 17.8792C3.33843 18.0208 3.52983 18.0958 3.72123 18.0958C3.91263 18.0958 4.09571 18.0208 4.24551 17.8792L10.4785 11.6458L16.7115 17.8792C16.853 18.0208 17.0444 18.0958 17.2358 18.0958C17.4272 18.0958 17.6103 18.0208 17.7601 17.8792C18.0513 17.5875 18.0513 17.1208 17.7601 16.8375L11.5271 10.5958Z"
      fill="currentColor"
    />
  </svg>
`;
export const lightBulbIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15.4104 20.2499H8.59045C8.11045 20.2499 7.71045 20.6399 7.71045 21.1299C7.71045 21.6199 8.10045 22.0099 8.59045 22.0099H15.4104C15.8904 22.0099 16.2905 21.6199 16.2905 21.1299C16.2905 20.6399 15.9004 20.2499 15.4104 20.2499Z"
      fill="currentColor"
    />
    <path
      d="M10.4604 2.14986C7.42045 2.73986 5.00045 5.20986 4.45045 8.24986C3.92045 11.1599 5.04045 13.8499 7.03045 15.5399C7.47045 15.9199 7.73045 16.4699 7.73045 17.0499V17.4999C7.73045 18.0499 8.18045 18.4999 8.73045 18.4999H15.3004C15.8504 18.4999 16.3004 18.0499 16.3004 17.4999V17.0499C16.3004 16.4699 16.5504 15.9199 17.0004 15.5399C18.6504 14.1299 19.7004 12.0299 19.7004 9.68986C19.7004 4.93986 15.3904 1.19986 10.4704 2.14986H10.4604ZM16.8304 8.59986C16.7204 8.64986 16.6004 8.66986 16.4904 8.66986C16.1504 8.66986 15.8204 8.46986 15.6804 8.13986C15.0504 6.65986 13.6104 5.69986 12.0004 5.69986C11.5204 5.69986 11.1204 5.30986 11.1204 4.81986C11.1204 4.32986 11.5104 3.93986 12.0004 3.93986C14.3104 3.93986 16.3904 5.31986 17.3004 7.44986C17.4904 7.88986 17.2804 8.40986 16.8404 8.59986H16.8304Z"
      fill="currentColor"
    />
  </svg>
`;

export const warningIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clip-path="url(#clip0_6784_6309)">
      <path
        d="M22.0828 17.8102L13.6328 4.47018C13.0228 3.50018 11.6328 3.50018 11.0128 4.47018L2.58284 17.8202C1.92284 18.8702 2.66284 20.2502 3.89284 20.2502H20.7728C22.0028 20.2502 22.7428 18.8702 22.0828 17.8102ZM12.3328 17.9202C11.8528 17.9202 11.4528 17.5302 11.4528 17.0402C11.4528 16.5502 11.8428 16.1602 12.3328 16.1602C12.8228 16.1602 13.2128 16.5502 13.2128 17.0402C13.2128 17.5302 12.8228 17.9202 12.3328 17.9202ZM13.2128 13.8302C13.2128 14.3102 12.8228 14.7102 12.3328 14.7102C11.8428 14.7102 11.4528 14.3202 11.4528 13.8302V9.34018C11.4528 8.86018 11.8428 8.46018 12.3328 8.46018C12.8228 8.46018 13.2128 8.85018 13.2128 9.34018V13.8302Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6784_6309">
        <rect width="24" height="24" fill="none" transform="translate(0.333008)" />
      </clipPath>
    </defs>
  </svg>
`;

export const clockIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clip-path="url(#clip0_6784_6320)">
      <path
        d="M12.667 2C7.14699 2 2.66699 6.48 2.66699 12C2.66699 17.52 7.14699 22 12.667 22C18.187 22 22.667 17.52 22.667 12C22.667 6.48 18.187 2 12.667 2ZM13.547 12.46L8.93699 15.69C8.78699 15.8 8.60699 15.85 8.43699 15.85C8.15699 15.85 7.88699 15.72 7.71699 15.48C7.43699 15.08 7.53699 14.54 7.92699 14.26L11.787 11.55V6.83C11.787 6.35 12.177 5.95 12.667 5.95C13.157 5.95 13.547 6.34 13.547 6.83V12.46Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6784_6320">
        <rect width="24" height="24" fill="none" transform="translate(0.666992)" />
      </clipPath>
    </defs>
  </svg>
`;

export const designThemeIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.515 21.685 12.8866 21.3024 13.0619C20.9305 13.2324 20.4688 13.2356 20.0706 13.0347C19.3628 12.6776 18.5628 12.4762 17.7143 12.4762C14.8214 12.4762 12.4762 14.8214 12.4762 17.7143C12.4762 18.5628 12.6776 19.3628 13.0347 20.0706C13.2356 20.4688 13.2324 20.9305 13.0619 21.3024C12.8866 21.685 12.515 22 12 22C6.47715 22 2 17.5228 2 12ZM12 2.95238C7.00314 2.95238 2.95238 7.00314 2.95238 12C2.95238 16.9969 7.00314 21.0476 12 21.0476C12.0811 21.0476 12.1486 21.0093 12.1961 20.9056C12.2486 20.7912 12.252 20.6336 12.1844 20.4996C11.7617 19.6619 11.5238 18.7152 11.5238 17.7143C11.5238 14.2954 14.2954 11.5238 17.7143 11.5238C18.7152 11.5238 19.6619 11.7617 20.4996 12.1844C20.6336 12.252 20.7912 12.2486 20.9056 12.1961C21.0093 12.1486 21.0476 12.0811 21.0476 12C21.0476 7.00314 16.9969 2.95238 12 2.95238ZM12.4762 7.71429C12.4762 6.66231 13.329 5.80952 14.381 5.80952C15.4329 5.80952 16.2857 6.66231 16.2857 7.71429C16.2857 8.76626 15.4329 9.61905 14.381 9.61905C13.329 9.61905 12.4762 8.76626 12.4762 7.71429ZM14.381 6.7619C13.855 6.7619 13.4286 7.1883 13.4286 7.71429C13.4286 8.24027 13.855 8.66667 14.381 8.66667C14.9069 8.66667 15.3333 8.24027 15.3333 7.71429C15.3333 7.1883 14.9069 6.7619 14.381 6.7619ZM6.7619 8.66667C6.7619 7.6147 7.6147 6.7619 8.66667 6.7619C9.71864 6.7619 10.5714 7.6147 10.5714 8.66667C10.5714 9.71864 9.71864 10.5714 8.66667 10.5714C7.6147 10.5714 6.7619 9.71864 6.7619 8.66667ZM8.66667 7.71429C8.14068 7.71429 7.71429 8.14068 7.71429 8.66667C7.71429 9.19265 8.14068 9.61905 8.66667 9.61905C9.19265 9.61905 9.61905 9.19265 9.61905 8.66667C9.61905 8.14068 9.19265 7.71429 8.66667 7.71429ZM7.71429 13.4286C7.1883 13.4286 6.7619 13.855 6.7619 14.381C6.7619 14.9069 7.1883 15.3333 7.71429 15.3333C8.24027 15.3333 8.66667 14.9069 8.66667 14.381C8.66667 13.855 8.24027 13.4286 7.71429 13.4286ZM5.80952 14.381C5.80952 13.329 6.66231 12.4762 7.71429 12.4762C8.76626 12.4762 9.61905 13.329 9.61905 14.381C9.61905 15.4329 8.76626 16.2857 7.71429 16.2857C6.66231 16.2857 5.80952 15.4329 5.80952 14.381Z"
      fill="currentColor"
    />
  </svg>
`;

export const rightArrowIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    width="17"
    height="8"
    viewBox="0 0 17 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_19290_142528)">
      <path
        d="M11.7896 6.96002C11.9496 6.54402 12.1256 6.16002 12.3176 5.80802C12.5096 5.44002 12.7256 5.09602 12.9656 4.77602H0.101562V2.80802H12.9656C12.7416 2.48802 12.5336 2.15202 12.3416 1.80002C12.1496 1.43202 11.9736 1.04002 11.8136 0.624023H13.6376C14.6296 1.79202 15.7176 2.68002 16.9016 3.28802V4.32002C15.7176 4.89602 14.6296 5.77602 13.6376 6.96002H11.7896Z"
        fill="#141414"
      />
    </g>
    <defs>
      <clipPath id="clip0_19290_142528">
        <rect width="17" height="7" fill="white" transform="translate(0 0.25)" />
      </clipPath>
    </defs>
  </svg>
`;

export const linkArrowIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.22656"
      y="11.7109"
      width="11"
      height="1.5"
      transform="rotate(-45 3.22656 11.7109)"
      fill="#1C75FF"
    />
    <rect x="4.23828" y="3.75586" width="8" height="1.5" fill="#1C75FF" />
    <path d="M10.7393 3.7627H12.2393V11.7627H10.7393V3.7627Z" fill="#1C75FF" />
  </svg>
`;

export const resetIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_13_50292)">
      <path
        d="M11.5 6.5H14V4"
        stroke="#6B6B6B"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7747 12.0002C10.9884 12.7421 10.001 13.2359 8.93577 13.4198C7.87053 13.6037 6.77471 13.4697 5.78523 13.0344C4.79574 12.5991 3.95648 11.8818 3.37229 10.9723C2.78811 10.0627 2.48491 9.00116 2.50058 7.92028C2.51625 6.83939 2.85009 5.78708 3.4604 4.89484C4.07071 4.0026 4.93041 3.30999 5.93209 2.90356C6.93378 2.49712 8.03303 2.39487 9.09249 2.6096C10.152 2.82432 11.1246 3.34649 11.889 4.11087C12.6247 4.85587 13.2322 5.55837 13.9997 6.50024"
        stroke="#6B6B6B"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_13_50292">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const spinner_icon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg class="${klass}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
    <g>
      <circle cx="12" cy="12" r="10" fill="none" stroke-width="3"></circle>
    </g>
  </svg>
`;

export const downloadIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clip-path="url(#clip0_12099_88007)">
      <path
        d="M10.5611 5.99C10.3211 5.99 10.1211 6.185 10.1211 6.43V9.945C10.1211 10.045 10.0111 10.13 9.88109 10.13H2.11609C1.98609 10.13 1.87609 10.045 1.87609 9.945V6.43C1.87609 6.19 1.68109 5.99 1.43609 5.99C1.19109 5.99 0.996094 6.185 0.996094 6.43V9.945C0.996094 10.53 1.49609 11.005 2.11109 11.005H9.87609C10.4911 11.005 10.9911 10.53 10.9911 9.945V6.43C10.9911 6.19 10.7961 5.99 10.5511 5.99H10.5611Z"
        fill="#1C75FF"
      />
      <path
        d="M5.69109 8.16C5.73109 8.2 5.78109 8.23 5.83109 8.255C5.88609 8.275 5.94109 8.29 6.00109 8.29C6.06109 8.29 6.11609 8.28 6.17109 8.255C6.22609 8.235 6.27109 8.2 6.31109 8.16L7.94109 6.53C8.11109 6.36 8.11109 6.08 7.94109 5.91C7.77109 5.74 7.49109 5.74 7.32109 5.91L6.44109 6.79V1.44C6.44109 1.2 6.24609 1 6.00109 1C5.75609 1 5.56109 1.195 5.56109 1.44V6.8L4.68109 5.92C4.51109 5.75 4.23109 5.75 4.06109 5.92C3.89109 6.09 3.89109 6.37 4.06109 6.54L5.69109 8.17V8.16Z"
        fill="#1C75FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_12099_88007">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const phoneIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.33497 2.83815C6.13249 2.33193 5.64221 2 5.09701 2H3.26316C2.56554 2 2 2.5654 2 3.26302C2 9.19281 6.80719 14 12.737 14C13.4346 14 14 13.4344 14 12.7368L14.0003 10.9026C14.0003 10.3574 13.6685 9.86724 13.1622 9.66475L11.4046 8.96196C10.9499 8.78007 10.4322 8.86193 10.056 9.17546L9.60235 9.55378C9.07258 9.99526 8.29309 9.96015 7.80546 9.47252L6.52815 8.19404C6.04052 7.70641 6.00449 6.92756 6.44596 6.39779L6.82422 5.9442C7.13774 5.56797 7.22033 5.05011 7.03844 4.59539L6.33497 2.83815Z"
      fill="#141414"
    />
  </svg>
`;

export const goodsPartnerLogoIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) =>
  html`<svg
    class="${klass}"
    width="215"
    height="24"
    viewBox="0 0 215 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0997 0.00819439C11.9859 0.00819439 11.8869 0.0901383 11.8652 0.203494L8.80508 16.4338C8.78069 16.5636 8.59637 16.5636 8.57062 16.4338L5.51182 0.203494C5.49013 0.0901383 5.39255 0.00819439 5.27736 0.00819439H0.238525C0.107065 0.00819439 0 0.116087 0 0.248563V23.7596C0 23.8921 0.107065 24 0.238525 24H3.33392C3.46538 24 3.57245 23.8921 3.57245 23.7596V8.417C3.57245 8.27224 3.7798 8.25175 3.80826 8.39379L6.86707 23.8061C6.88875 23.9181 6.98769 23.9986 7.10017 23.9986H10.281C10.3948 23.9986 10.4924 23.9181 10.5141 23.8061L13.5729 8.39379C13.6013 8.25175 13.8087 8.27224 13.8087 8.417V23.7596C13.8087 23.8921 13.9157 24 14.0472 24H17.1426C17.2741 24 17.3811 23.8921 17.3811 23.7596V0.248563C17.3811 0.116087 17.2741 0.00819439 17.1426 0.00819439H12.0997Z"
      fill="white"
    />
    <path
      d="M45.4118 4.33347C44.2355 1.41353 41.6402 0 39.0503 0C36.6935 0 34.3421 1.16907 33.0682 3.43618C33.0438 3.47988 33.018 3.52222 32.9923 3.56866C32.9733 3.60143 32.9394 3.61782 32.9056 3.61782C32.8717 3.61782 32.8378 3.60143 32.8188 3.56866C32.7917 3.52222 32.766 3.47988 32.7429 3.43618C31.4663 1.16907 29.1149 0 26.7581 0C24.1682 0 21.5716 1.41353 20.3966 4.33347C19.6146 6.27417 19.6661 8.2736 20.2163 10.273C20.4061 10.9627 20.65 11.6224 20.9373 12.2574C21.2748 13.0045 21.6746 13.7174 22.1259 14.4016C22.1354 14.4153 22.1747 14.4754 22.1855 14.4904C22.4593 14.9001 22.7493 15.2989 23.0556 15.6909C25.743 19.1161 29.0756 21.7575 32.7632 23.959C32.7985 23.9795 32.8608 23.9973 32.9028 23.9973C32.9449 23.9973 33.0085 23.9795 33.0424 23.959C36.7301 21.7575 40.064 19.1161 42.7501 15.6909C43.0564 15.3003 43.3478 14.9001 43.6202 14.4904C43.631 14.474 43.6703 14.4153 43.6798 14.4016C44.1311 13.7174 44.5309 13.0045 44.8684 12.2574C45.1557 11.6224 45.3996 10.9614 45.5894 10.273C46.1396 8.27224 46.1911 6.27417 45.4091 4.33347H45.4118ZM37.7872 1.82462C38.1924 1.73038 38.6139 1.67985 39.0489 1.67985C40.0667 1.67985 41.0398 1.95982 41.8651 2.48836C42.7637 3.0647 43.4372 3.8978 43.8668 4.96443V4.9658C43.917 5.09145 43.9305 5.23212 43.898 5.36323C43.7042 6.12667 42.6498 6.93928 40.991 7.58254C40.5492 7.75326 40.0762 7.90759 39.5788 8.04689C39.5151 8.06464 39.4514 8.01684 39.4501 7.94992C39.4379 7.02942 39.3471 6.11711 39.1573 5.21709C38.847 3.74347 38.3374 2.67274 37.7357 1.98987C37.6855 1.93251 37.7126 1.84101 37.7872 1.82462ZM29.8318 2.75878C30.0758 2.75878 30.767 3.28185 31.225 4.83879C31.2427 4.90024 31.3118 5.12422 31.3118 5.12422C31.5273 5.82894 32.1737 6.30968 32.9056 6.30968C33.6374 6.30968 34.2838 5.82894 34.4993 5.12422C34.4993 5.12422 34.5684 4.90024 34.5861 4.83879C35.0441 3.28322 35.734 2.75878 35.9793 2.75878C36.2801 2.75878 37.0865 3.46623 37.5297 5.56672C37.7153 6.44898 37.8007 7.37905 37.7872 8.3733C37.7872 8.42247 37.7519 8.4648 37.7031 8.473C36.2219 8.73658 34.5942 8.87589 32.9069 8.87589C31.2196 8.87589 29.5906 8.73658 28.1107 8.473C28.0632 8.4648 28.028 8.42247 28.0266 8.3733C28.0131 7.37905 28.0985 6.44898 28.2841 5.56672C28.7273 3.46623 29.5337 2.75878 29.8345 2.75878H29.8318ZM37.6435 10.3058C37.63 10.4192 37.6137 10.5339 37.5974 10.6486C37.3616 12.2889 36.932 13.8512 36.2869 15.4218C36.2571 15.4942 36.1893 15.5448 36.1121 15.5543C35.0889 15.6868 34.0101 15.7564 32.9028 15.7564C31.7956 15.7564 30.7182 15.6868 29.6936 15.5543C29.6164 15.5448 29.5486 15.4942 29.5188 15.4218C28.8737 13.8499 28.4454 12.2889 28.2082 10.6486C28.192 10.5339 28.1771 10.4192 28.1622 10.3058C28.154 10.2389 28.211 10.1829 28.2774 10.1938C29.7695 10.4328 31.347 10.5544 32.9015 10.5544C34.456 10.5544 36.0335 10.4328 37.5256 10.1938C37.592 10.1829 37.6503 10.2389 37.6408 10.3058H37.6435ZM21.9402 4.9658V4.96443C22.3698 3.8978 23.0434 3.0647 23.9419 2.48836C24.7673 1.95982 25.7403 1.67985 26.7581 1.67985C27.1932 1.67985 27.616 1.72902 28.0199 1.82462C28.093 1.84237 28.1215 1.93388 28.0714 1.98987C27.4696 2.67274 26.9601 3.74484 26.6497 5.21709C26.46 6.11711 26.3692 7.03079 26.357 7.94992C26.357 8.01684 26.2933 8.06464 26.2282 8.04689C25.7308 7.90759 25.2565 7.75326 24.816 7.58254C23.1586 6.93928 22.1028 6.12667 21.909 5.36323C21.8751 5.23212 21.8887 5.09145 21.9402 4.9658ZM25.3121 14.4481C25.3039 14.4453 25.2972 14.4412 25.289 14.4385C24.1059 13.9387 23.1504 13.0113 22.588 11.8491C22.569 11.8108 22.3793 11.3957 22.3766 11.3888C22.1516 10.8726 21.9673 10.3522 21.8223 9.82507C21.6298 9.12445 21.5174 8.45798 21.4835 7.82291C21.4794 7.73414 21.5783 7.68224 21.6475 7.73687C22.7588 8.64235 24.4298 9.33751 26.3637 9.81142C26.4058 9.82098 26.4356 9.85648 26.4396 9.90019C26.4708 10.2307 26.5115 10.5612 26.5589 10.8917C26.7757 12.394 27.1308 13.7516 27.5781 15.0121C27.6052 15.0886 27.5374 15.1651 27.4588 15.146C26.6836 14.9548 25.9612 14.7226 25.3107 14.4494L25.3121 14.4481ZM29.592 19.7881C28.337 18.8157 27.2013 17.7996 26.1754 16.7316C26.1035 16.6565 26.1754 16.5335 26.2757 16.5622C26.9329 16.7548 27.6295 16.9173 28.3573 17.0484C28.3898 17.0539 28.417 17.0757 28.4305 17.1058C28.8425 18.014 29.2802 18.8608 29.741 19.6556C29.7966 19.7526 29.68 19.855 29.592 19.7867V19.7881ZM35.3409 17.4855C34.6538 18.8416 33.8746 20.1063 32.9855 21.2945C32.9449 21.3491 32.8635 21.3491 32.8229 21.2945C31.9338 20.1049 31.1532 18.8403 30.4675 17.4855C30.4309 17.4144 30.4878 17.3311 30.5664 17.338C31.328 17.4035 32.1114 17.439 32.9042 17.439C33.697 17.439 34.4804 17.4035 35.242 17.338C35.3206 17.3311 35.3775 17.4144 35.3409 17.4855ZM39.6317 16.7316C38.6057 17.7996 37.47 18.8157 36.2151 19.7881C36.127 19.8564 36.0091 19.7526 36.066 19.657C36.5268 18.8621 36.9645 18.0154 37.3765 17.1072C37.3901 17.0771 37.4172 17.0553 37.4497 17.0498C38.1775 16.9187 38.8754 16.7562 39.5314 16.5636C39.6317 16.5349 39.7035 16.6565 39.6317 16.7329V16.7316ZM43.9847 9.82507C43.8397 10.3522 43.6554 10.8726 43.4305 11.3888C43.4277 11.3957 43.238 11.8095 43.219 11.8491C42.658 13.0113 41.7011 13.9387 40.518 14.4385C40.5099 14.4412 40.5031 14.4453 40.495 14.4481C39.8445 14.7212 39.1221 14.9534 38.3469 15.1446C38.2683 15.1637 38.2005 15.0872 38.2276 15.0108C38.6749 13.7502 39.0299 12.3926 39.2468 10.8903C39.2942 10.5598 39.3349 10.2293 39.366 9.89882C39.3701 9.85649 39.4013 9.82098 39.4419 9.81005C41.3759 9.33614 43.0469 8.64098 44.1582 7.7355C44.226 7.67951 44.3263 7.73277 44.3222 7.82154C44.2883 8.45798 44.1758 9.12309 43.9834 9.82371L43.9847 9.82507Z"
      fill="white"
    />
    <path
      d="M209.996 23C206.669 23 204.777 21.2278 204.777 18.2639V17.775H207.982V18.2945C207.982 19.6083 208.683 20.2194 209.843 20.2194C210.942 20.2194 211.674 19.7 211.674 18.4472C211.674 17.1945 210.484 16.7361 208.958 16.1861C207.005 15.4528 204.961 14.4445 204.961 11.3889C204.961 8.63891 206.639 6.8667 209.812 6.8667C212.772 6.8667 214.695 8.5778 214.695 11.3889V11.6945H211.552V11.3278C211.552 10.1667 210.942 9.61669 209.843 9.61669C208.958 9.61669 208.195 10.075 208.195 11.2361C208.195 12.55 209.385 13.0084 211.003 13.6195C212.956 14.3528 215 15.3 215 18.2639C215 21.1667 213.291 23 209.996 23Z"
      fill="white"
    />
    <path
      d="M202.441 6.8667C202.899 6.8667 203.234 6.92781 203.479 7.05003V10.2889C203.204 10.2278 202.868 10.1972 202.533 10.1972C200.427 10.1972 199.328 11.5722 199.328 14.2V22.6944H195.972V7.17225H198.871L198.932 10.0445C199.451 7.90558 200.641 6.8667 202.441 6.8667Z"
      fill="white"
    />
    <path
      d="M188.073 6.8667C191.521 6.8667 193.413 8.79169 193.413 12.2445V15.6667H186.059V17.9583C186.059 19.425 186.761 20.1278 188.134 20.1278C189.507 20.1278 190.209 19.425 190.209 17.9278V17.6222H193.413V17.775C193.413 21.0444 191.491 23 188.073 23C184.594 23 182.702 21.0444 182.702 17.6222V12.2445C182.702 8.79169 184.594 6.8667 188.073 6.8667ZM186.059 13.1306H190.148V11.8778C190.148 10.4111 189.416 9.70836 188.103 9.70836C186.791 9.70836 186.059 10.4111 186.059 11.8778V13.1306Z"
      fill="white"
    />
    <path
      d="M176.312 6.8667C178.814 6.8667 180.187 8.42503 180.187 11.6945V22.6944H176.861V12.1834C176.861 10.5334 176.342 9.80002 175.091 9.80002C173.779 9.80002 172.985 10.6861 172.985 12.7334V22.6944H169.629V7.17225H172.558L172.589 9.46391C173.199 7.81392 174.511 6.8667 176.312 6.8667Z"
      fill="white"
    />
    <path
      d="M167.356 9.95274H164.518V18.3555C164.518 19.5472 164.945 20.0361 166.044 20.0361C166.441 20.0361 166.868 19.9749 167.356 19.7916V22.6333C166.715 22.9083 166.136 22.9999 165.373 22.9999C162.535 22.9999 161.192 21.5944 161.192 18.7833V9.95274H159.117V7.17219H161.314L161.589 3.01664H164.518V7.17219H167.356V9.95274Z"
      fill="white"
    />
    <path
      d="M156.818 6.8667C157.275 6.8667 157.611 6.92781 157.855 7.05003V10.2889C157.58 10.2278 157.245 10.1972 156.909 10.1972C154.804 10.1972 153.705 11.5722 153.705 14.2V22.6944H150.348V7.17225H153.247L153.308 10.0445C153.827 7.90558 155.017 6.8667 156.818 6.8667Z"
      fill="white"
    />
    <path
      d="M147.819 22.6944H144.737C144.615 22.5111 144.493 21.625 144.462 20.4028C143.882 22.0222 142.57 23 140.648 23C138.298 23 136.803 21.4722 136.803 18.9972C136.803 16.6139 137.84 15.0861 140.983 13.9861C143.699 13.0389 144.096 12.7028 144.096 11.7556V11.6028C144.096 10.2889 143.547 9.6778 142.357 9.6778C141.044 9.6778 140.465 10.4417 140.465 11.7556V12.0306H137.352V11.8472C137.352 8.70002 139.122 6.8667 142.387 6.8667C146.018 6.8667 147.422 8.76114 147.422 12.275V18.1722C147.422 20.4028 147.575 21.8083 147.819 22.6944ZM141.807 20.1889C143.15 20.1889 144.096 19.2417 144.096 17.1945V15.0861C143.76 15.4222 143.119 15.7278 141.99 16.1861C140.648 16.7361 140.129 17.4695 140.129 18.4778C140.129 19.5778 140.678 20.1889 141.807 20.1889Z"
      fill="white"
    />
    <path
      d="M124.304 22.6944V1.30554H129.827C133.642 1.30554 135.442 3.13887 135.442 6.86664V8.45553C135.442 12.1833 133.642 14.0166 129.827 14.0166H127.783V22.6944H124.304ZM127.783 10.9611H129.827C131.323 10.9611 131.963 10.2889 131.963 8.5472V6.74442C131.963 5.03331 131.323 4.39165 129.827 4.39165H127.783V10.9611Z"
      fill="white"
    />
    <path
      d="M111.776 23C108.449 23 106.557 21.2278 106.557 18.2639V17.775H109.762V18.2945C109.762 19.6083 110.463 20.2194 111.623 20.2194C112.721 20.2194 113.454 19.7 113.454 18.4472C113.454 17.1945 112.264 16.7361 110.738 16.1861C108.785 15.4528 106.741 14.4445 106.741 11.3889C106.741 8.63891 108.419 6.8667 111.592 6.8667C114.552 6.8667 116.475 8.5778 116.475 11.3889V11.6945H113.332V11.3278C113.332 10.1667 112.721 9.61669 111.623 9.61669C110.738 9.61669 109.975 10.075 109.975 11.2361C109.975 12.55 111.165 13.0084 112.783 13.6195C114.735 14.3528 116.78 15.3 116.78 18.2639C116.78 21.1667 115.071 23 111.776 23Z"
      fill="white"
    />
    <path
      d="M104.591 22.6944H101.509C101.356 22.5111 101.234 21.6555 101.204 20.4333C100.593 22.0527 99.2506 22.9999 97.4502 22.9999C94.948 22.9999 93.5138 21.4416 93.5138 18.1416V11.6944C93.5138 8.42497 94.948 6.86664 97.4502 6.86664C98.9149 6.86664 100.105 7.50831 100.807 8.63886V1.30554H104.164V18.1722C104.164 20.4027 104.347 21.8083 104.591 22.6944ZM98.6708 20.0666C99.983 20.0666 100.807 19.15 100.807 17.1333V12.7333C100.807 10.7166 99.983 9.79997 98.6708 9.79997C97.3587 9.79997 96.8704 10.5944 96.8704 12.1222V17.7444C96.8704 19.2416 97.3587 20.0666 98.6708 20.0666Z"
      fill="white"
    />
    <path
      d="M85.8285 23C82.4414 23 80.5189 21.0444 80.5189 17.6222V12.2445C80.5189 8.79169 82.4414 6.8667 85.8285 6.8667C89.2462 6.8667 91.1686 8.79169 91.1686 12.2445V17.6222C91.1686 21.0444 89.2462 23 85.8285 23ZM85.8285 20.0667C87.2017 20.0667 87.812 19.2111 87.812 17.8972V11.9695C87.812 10.6556 87.2017 9.80002 85.8285 9.80002C84.4553 9.80002 83.8756 10.6556 83.8756 11.9695V17.8972C83.8756 19.2111 84.4859 20.0667 85.8285 20.0667Z"
      fill="white"
    />
    <path
      d="M72.9252 23C69.5381 23 67.6156 21.0444 67.6156 17.6222V12.2445C67.6156 8.79169 69.5381 6.8667 72.9252 6.8667C76.3429 6.8667 78.2653 8.79169 78.2653 12.2445V17.6222C78.2653 21.0444 76.3429 23 72.9252 23ZM72.9252 20.0667C74.2984 20.0667 74.9087 19.2111 74.9087 17.8972V11.9695C74.9087 10.6556 74.2984 9.80002 72.9252 9.80002C71.5521 9.80002 70.9723 10.6556 70.9723 11.9695V17.8972C70.9723 19.2111 71.5826 20.0667 72.9252 20.0667Z"
      fill="white"
    />
    <path
      d="M59.6148 23C56.014 23 54 20.9222 54 17.2861V6.74443C54 3.07777 55.9835 1 59.6148 1C63.2155 1 65.2295 3.07777 65.2295 6.74443V8.24165H61.9644V6.5611C61.9644 4.88055 61.1405 4.08611 59.7063 4.08611C58.2721 4.08611 57.4787 4.88055 57.4787 6.5611V17.4389C57.4787 19.1194 58.2721 19.9139 59.7063 19.9139C61.1405 19.9139 61.9644 19.1194 61.9644 17.4389V13.8028H59.8284V10.6555H65.2295V17.2861C65.2295 20.9222 63.2155 23 59.6148 23Z"
      fill="white"
    />
  </svg> `;
export const key_visual_3d_icon_urls = {
  malove: '//s3.marpple.co/files/u_4648126/2025/1/original/473ecd80ccba9526ee479968e59e170610ac8bb939.webp',
  malove_popular_creator:
    '//s3.marpple.co/files/u_4648126/2025/1/original/46bd8d341ead5e681b5bb71588c3b01848ea478136.webp',
  malove_search:
    '//s3.marpple.co/files/u_4648126/2025/1/original/bae97ba5d61368ba9bff0a71f2f54a59dd32af3a37.webp',
  malove_clover:
    '//s3.marpple.co/files/u_4648126/2025/1/original/42bfd21fb67082b8e7425b96d33e924fb7cd26ba38.webp',
  malove_puzzle:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b93c890d1bb9e913781b04badb1721947a7fcd6823.webp',
  malove_furry:
    '//s3.marpple.co/files/u_4648126/2025/1/original/de5bedce8bca0b8180bfdf7ded548f25cba94f7c22.webp',
  malove_cs:
    '//s3.marpple.co/files/u_4648126/2025/1/original/ead4dcaba248b7bf56e3d542ea3b76039d90563f12.webp',
  malove_youtube:
    '//s3.marpple.co/files/u_4648126/2025/1/original/def472ecd517844f85017d59eb0be9e715256b4c11.webp',
  malove_creative_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/c315519b603aa313e58ff8e479b8ed4b89c0f2b55.webp',
  malove_creative_5:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e6384b88abee475a77d0813d903355ff266da6f56.webp',
  malove_creative_6:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0b40014e4d91744768fc22b23c2c86fed8219b9e7.webp',
  malove_creative_7:
    '//s3.marpple.co/files/u_4648126/2025/1/original/3a265ffb055068c3572957188897df0651ce36428.webp',
  malove_creative_8:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6a3d4bb1da07c585d64b9385f053355a840aaf1e9.webp',
  malove_virtual:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e900409f560d3957c5eab61687265b0d3cea707e10.webp',
  malove_thankyou:
    '//s3.marpple.co/files/u_4648126/2025/1/original/5b0167c9af203161a0156d4c4a5acc55d9246cab4.webp',
  malove_congratulation:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7aef402e0d4dce1bdc63eb1d9fce406c175f4cf43.webp',
  malove_birthday:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7ab52927cf9f673efa732db285c0163cf4c724c91.webp',
  malove_cheerup:
    '//s3.marpple.co/files/u_4648126/2025/1/original/56599b51645630bc672fa5b339393e0b498a46be2.webp',
  malove_enterprise_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7706ad09ffc4ee4815c9b4661e63be0d42b792a621.webp',
  malove_enterprise_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/59492c7462849b9accd4e1ebf312984fc3e3b8bf20.webp',
  keyring: '//s3.marpple.co/files/u_4648126/2025/1/original/e6de94b6dc0a007bd9d5373d89f4ecbff160253533.webp',
  cousion: '//s3.marpple.co/files/u_4648126/2025/1/original/4401243d5ef8ea7f89e30f46128e0339f9b5b6a629.webp',
  cousion_square:
    '//s3.marpple.co/files/u_4648126/2025/1/original/781761a559b443f9d6c0a5692bada1a98e61a59630.webp',
  cup: '//s3.marpple.co/files/u_4648126/2025/1/original/bb9b67f8d38297bf9afb2b01fb0ab4ee0d71459431.webp',
  cup_2: '//s3.marpple.co/files/u_4648126/2025/1/original/e1dfbaceb69d4cb275cbc67b1bf5ffade1eab14a32.webp',
  phonecase:
    '//s3.marpple.co/files/u_4648126/2025/1/original/59ce7fc5ae20bf81899e51031e6cf74ff349719134.webp',
  sticker: '//s3.marpple.co/files/u_4648126/2025/1/original/0e4d38d44b84be100190268b950cfb2f255c14a535.webp',
  present_box:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0bafc6903af8a8efeafd0cd41429c3702e0c8bee15.webp',
  delivery_box:
    '//s3.marpple.co/files/u_4648126/2025/1/original/47edaa56949ad28ae8e84534fbebb818383cb7d613.webp',
  pod_product:
    '//s3.marpple.co/files/u_4648126/2025/1/original/db1ff86768761ce62710e51d446c002d557ee90127.webp',
  pod_shirt:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a10521bc832d32a626f5573fe154c93a09b09efd28.webp',
  pod_design_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/181760e1efdce320c22cf3795fd4afdc84ae6e0e25.webp',
  pod_design_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/ee45963555fd998c7334c3e94bcde0d0c131ceef26.webp',
  delivery: '//s3.marpple.co/files/u_4648126/2025/1/original/181760e1efdce320c22cf3795fd4afdc84ae6e0e25.webp',
  like_product:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b141a895b9af559447d885f3cfc994819c61bfed17.webp',
  like_creator:
    '//s3.marpple.co/files/u_4648126/2025/1/original/571463e6162157d0ddf3f74b559a7a90353c8de916.webp',
  limited_edition_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0783312a539d3d3461e1e83a11df3a76b4eeca1c18.webp',
  limited_edition_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/85a1cb7267f0ad27048baf24c01a2f43d48914b519.webp',
  note: '//s3.marpple.co/files/u_4648126/2025/1/original/18aab258c0d01adbe37e23385df62b04ef4fedae24.webp',
  popup_store:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7f76f76c5a724aa833e3d7ff56059f79fdc308211.webp',
  wiki_1: '//s3.marpple.co/files/u_4648126/2025/1/original/3901fe3c61a5c53e766c309c03d8f6bff4dd13e32.webp',
  wili_2: '//s3.marpple.co/files/u_4648126/2025/1/original/db2eff76c260dfe407b45a31d419ea3afabb321a3.webp',
  wiki_3: '//s3.marpple.co/files/u_4648126/2025/1/original/6d059d143d0e73c8f6d021d6fcf4ede403467cac4.webp',
  newpost: '//s3.marpple.co/files/u_4648126/2025/1/original/b909d26ad621afe03c061a8a3a5998ec44c4536b5.webp',
  book_red: '//s3.marpple.co/files/u_4648126/2025/1/original/f2ee99fa5820a0e9f77139c111ad7d90e165fcd76.webp',
  book_blue: '//s3.marpple.co/files/u_4648126/2025/1/original/0cb49675501f22f20f89334e47fb1df55be8475a7.webp',
  cart: '//s3.marpple.co/files/u_4648126/2025/1/original/ce894b9a5bbd37d8594ef61e2515390d8b48cd0e8.webp',
  ranking_star:
    '//s3.marpple.co/files/u_4648126/2025/1/original/3612e0f005b9b4e13a05936aabe5de5e9ec8d94e9.webp',
  ranking_trophy:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f19efb4409a3f66b95069aa04f27939dab58c86510.webp',
  payment: '//s3.marpple.co/files/u_4648126/2025/1/original/2df8d8b29a1113ba75e35b2780acb014adde65f21.webp',
  chart: '//s3.marpple.co/files/u_4648126/2025/1/original/ff3ab385f3c851556df1d9ae8ae2f5f0a5a7a6a511.webp',
  review: '//s3.marpple.co/files/u_4648126/2025/1/original/b97af745bf86b623b30e0a9d1967fd07343d90a312.webp',
  like_tag: '//s3.marpple.co/files/u_4648126/2025/1/original/4ae7500eae2d661b8ff63503ca4a6f149bba58b313.webp',
  like_btn: '//s3.marpple.co/files/u_4648126/2025/1/original/0fc23ecb50cb3d27ba97fc1cd68cead0a5a158ed14.webp',
  qna: '//s3.marpple.co/files/u_4648126/2025/1/original/e530823ed1f3256d920a57c6dc544e5c2c81834f15.webp',
  product_empty:
    '//s3.marpple.co/files/u_4648126/2025/5/original/0a65f8b3255876902b0d8d06c353435835de0e601.png',
  ticket_creator:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6d9fbda8836976ce765f3fa82e1d73302db2b39c17.webp',
  ticket_m_pluse:
    '//s3.marpple.co/files/u_4648126/2025/1/original/28f0b66498e1fb1281f335d8e242dc84b521096318.webp',
  ticket_enterprise:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e990367497d73bab643ab73fbdd4e0ffcdef117019.webp',
  coin: '//s3.marpple.co/files/u_4648126/2025/1/original/3897d7de25a08f6dde061be8324a6ce70ec9cbec20.webp',
  clip: '//s3.marpple.co/files/u_4648126/2025/1/original/ce8d395c38568257c3ca9d25951b61f84f62113b21.webp',
  notice: '//s3.marpple.co/files/u_4648126/2025/1/original/b35554fa365a678fd6b434dff8b408c1056f203122.webp',
  timer: '//s3.marpple.co/files/u_4648126/2025/1/original/d56e67865015deacf10ae990a2c8045f146931e223.webp',
  sns: '//s3.marpple.co/files/u_4648126/2025/1/original/26c49e33ada564efb51ba2d0e5bd27b22b2f8ff624.webp',
  payment_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/bff2ae39454c704af5e3bd25325d86c27bb6258225.webp',
  money: '//s3.marpple.co/files/u_4648126/2025/1/original/dc520d9180829ff967077adfe0e9299dd3a1f52a26.webp',
  coins: '//s3.marpple.co/files/u_4648126/2025/1/original/c23392ecbe8a4fbcb2e094969a715bb5f484e8c927.webp',
  no_image: '//s3.marpple.co/files/u_4648126/2025/1/original/69c4810f248ad7897fea6432385ef69659e0d5db28.webp',
  sale: '//s3.marpple.co/files/u_4648126/2025/1/original/f6f1d88a1f80030ba2637a169789a098dc2ed87929.webp',
  time_limit:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b23866c35aaac71222d361d4238b1ad4bf3bfccb30.webp',
  truck_1: '//s3.marpple.co/files/u_4648126/2025/1/original/cc0384ec16763bfc42abd2c48fcec66bbfb6769431.webp',
  truck_2: '//s3.marpple.co/files/u_4648126/2025/1/original/7755df1a7ecdcad7637e8071141ea740e0d171f832.webp',
  bouquet_mini:
    '//s3.marpple.co/files/u_4648126/2025/1/original/65e71db14d23a04efdcb50f537521152158cbdf833.webp',
  bouquet: '//s3.marpple.co/files/u_4648126/2025/1/original/c66a96c3141fea6c264ac779d03e56206105c47634.webp',
  ballons: '//s3.marpple.co/files/u_4648126/2025/1/original/5213544e6753a7813b18a5dd71e1f7c64e9b868f35.webp',
  present_boxed:
    '//s3.marpple.co/files/u_4648126/2025/1/original/977461a1eb3e261c2bd3f9cb931ff03805588c7436.webp',
  cup_cake: '//s3.marpple.co/files/u_4648126/2025/1/original/8616c8c85c09b7e53fc8b4c19b1e168a2ef1eff837.webp',
  letter_ballon_heart_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/de8a0674f7ac302b24f155295a337ea6b24ab53a38.webp',
  letter_ballon_heart_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/baf04cffd136a33f8ff5e05acbf04c74af2b474239.webp',
  letter_ballon_m_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/4b5aa19878ab9428dd609e23fdefefcb9ac850de40.webp',
  letter_ballon_m_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/66b212e26613917c0e92759dc40393997e681e2c41.webp',
  wine_glass_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/66386b8dad90dad8f7ef14bea02cb4d3e0f142d642.webp',
  wine_glass_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/aba7718bc01ee07fae01dc77f87450c028fa6dcd43.webp',
  ballon_birthday:
    '//s3.marpple.co/files/u_4648126/2025/1/original/4128ab954d925319f1fd573ce48c314835f1295144.webp',
  cake_cutted:
    '//s3.marpple.co/files/u_4648126/2025/1/original/ed741149650860b8583240d3a4a9865861f56c2845.webp',
  cake_piece:
    '//s3.marpple.co/files/u_4648126/2025/1/original/d1f6129e9aae094fedfbf1bcd426d0cb940cc46646.webp',
  cake_whole:
    '//s3.marpple.co/files/u_4648126/2025/1/original/868054ff99e1851bd492e9c609a90c17dc06e2eb47.webp',
  garlands_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/86dbdaf912bb849d6596914bd9e1c103cadc2ec948.webp',
  garlands_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/72e9f390de920c85e21873d87057813ce6277ffd49.webp',
  garlands_3:
    '//s3.marpple.co/files/u_4648126/2025/1/original/9d4709bec0bdfb562075d7d930785eef5e87bca850.webp',
  vase_clover:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f313564ef668b44dff4ea2ed0967d4fb8b9c01ed51.webp',
  cheerup_trophy:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0810e4718385ab12766bac7cc3342b9f13ddfa7f1.webp',
  loud_speaker:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a6c12b501206309d3cadb4ded6028469cfc7418126.webp',
  cheerup_stick:
    '//s3.marpple.co/files/u_4648126/2025/1/original/20cd4d472de8cf4d28c96ebf5267796eb963119225.webp',
  good_luck_card:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f036bde9528890be7ff157474c331ef3b5cffa9924.webp',
  collection:
    '//s3.marpple.co/files/u_4648126/2025/1/original/c8bf4145cac154209503a96abce3fb39ad08927623.webp',
  check_out:
    '//s3.marpple.co/files/u_4648126/2025/1/original/074e863deef68efdb5bc054815a97ec8238c518522.webp',
  party_balloon:
    '//s3.marpple.co/files/u_4648126/2025/1/original/4bd5851ca0540f4efbf0da466ae3bb5ed0f7be3121.webp',
  party_balloon_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/5cc447418e3c786d71b8ce2088e816b2bba0c6b620.webp',
  party_balloon_3:
    '//s3.marpple.co/files/u_4648126/2025/1/original/65c6a7f5d3a30e12653b27477aec4b6886f7c73819.webp',
  party_balloon_3_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7c149ec67bfc795aa4373d58a18d2214f8bf849d18.webp',
  party_balloon_4:
    '//s3.marpple.co/files/u_4648126/2025/1/original/d9e8656a7d2375362c15c55409d52cd75a98d5eb17.webp',
  party_balloon_5:
    '//s3.marpple.co/files/u_4648126/2025/1/original/58129a1aadc134536df1aba76984c3d89df43b4f16.webp',
  '500_error':
    '//s3.marpple.co/files/u_4648126/2025/1/original/870ed5b26a7bf2a268d3ed5d81ce497c45343a5815.webp',
  delivery_complete:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6305794d49712163ce4d5f5f86ff18423a31d4c114.webp',
  '404_error':
    '//s3.marpple.co/files/u_4648126/2025/1/original/964e3655346b6c5d128e347f0245cc18260e8c8013.webp',
  explorer_error:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6305794d49712163ce4d5f5f86ff18423a31d4c114.webp',
  explorer_error_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/78f9c46b13697c04a03b8662c26990947919ed0f11.webp',
  prepare_store:
    '//s3.marpple.co/files/u_4648126/2025/1/original/870aeddd964fca140e389842dc89afc33dc5ee569.webp',
  prepare_store_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b9eb13fd78bd4dc3818825df96e9f714c260816f10.webp',
  siren_1: '//s3.marpple.co/files/u_4648126/2025/1/original/6cd753583b538e5e1991e720076f5f9a7a44a26e8.webp',
  email: '//s3.marpple.co/files/u_4648126/2025/1/original/89b1b7b2bb722bca2b922eddad75a102958bac467.webp',
  store: '//s3.marpple.co/files/u_4648126/2025/1/original/20c1054a78c5640d9b2bfb9195170c4592f759756.webp',
  digital: '//s3.marpple.co/files/u_4648126/2025/1/original/31bcef3ec9ae88dade90ed53d3c3e6fa88f4cd815.webp',
  siren_2: '//s3.marpple.co/files/u_4648126/2025/1/original/53137da265bcbd073857a2b9d8db25978dc7727b4.webp',
  cancel_1: '//s3.marpple.co/files/u_4648126/2025/1/original/af731909ffcb1acbee87b16e05f8b0a81e01f5113.webp',
  cancel_2: '//s3.marpple.co/files/u_4648126/2025/1/original/e5f6a48889b8b2ef00b85693d53055cbaea60b512.webp',
  cancel_3: '//s3.marpple.co/files/u_4648126/2025/1/original/2e093335832d38de2570775bce82b57431fadc0757.webp',
  popup: '//s3.marpple.co/files/u_4648126/2025/1/original/edfc8808eabc58a7539dceac84933d00afb5d4591.webp',
  membership_goods_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/03683088126dc986864bcdb0df38f7f69e1f273556.webp',
  membership_goods_white:
    '//s3.marpple.co/files/u_4648126/2025/1/original/05177e033d17ca3b3c599968168373cf3fd147f155.webp',
  membership_meet_fan:
    '//s3.marpple.co/files/u_4648126/2025/1/original/cb426b0135ef442ccf20dcaa4f5ed1499096bc2c54.webp',
  membership_special_myluv:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7bdf0237343858f865ac898d3a1e2ccab7368aca53.webp',
  membership_diamond_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a134b7ad73abd1df83dc674be9a42174b92db71152.webp',
  membership_diamond_sliver:
    '//s3.marpple.co/files/u_4648126/2025/1/original/3d1937a249db34e4cff240515ca315a53e9477df51.webp',
  membership_badge_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/1289a778461da70ab9f7c995377839790ceacc9350.webp',
  membership_badge_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/01e46e426fb796773896d8ec20e646bb19f96e8a49.webp',
  membership_badge_silver:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a190ae23f6831569da1b490f8ee3b8a27f726ae148.webp',
  membership_comission_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0d89287f63b37cf789ac79efce89bed4d2f2d2d047.webp',
  membership_comission_white:
    '//s3.marpple.co/files/u_4648126/2025/1/original/7506650cf3922fa492e69e8280f71579a15bc0da46.webp',
  membership_community:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b488907074d2a4e590abb82c52835504588f502845.webp',
  membership_donation_silver:
    '//s3.marpple.co/files/u_4648126/2025/1/original/5fcd62ae82498fdb98d65d21c05f2c638ac0057344.webp',
  membership_donation_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e9ceddf2fa01a5e7ecd138bac9388d5e62e1340143.webp',
  membership_donation_completed:
    '//s3.marpple.co/files/u_4648126/2025/1/original/05086bae4f1e3eb27cc48c523a2b2b7a2e45ed6842.webp',
  membership_fan_cafe_ciety:
    '//s3.marpple.co/files/u_4648126/2025/1/original/6fa16873cdb22c0b6127ab6745f2862f42fdc6f541.webp',
  membership_fan_cafe:
    '//s3.marpple.co/files/u_4648126/2025/1/original/2112ac48e01409ae51d7872364f30eeb6d55f6da40.webp',
  membership_subscribe:
    '//s3.marpple.co/files/u_4648126/2025/1/original/3860cc6536429882bc7a1517092547896772d24f39.webp',
  myluv_sad:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e026946bbe479cc69683733fa3bd24f30f91884538.webp',
  myluv_sad_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/9a271e0fda187aacfea75723bf91758211ab66a337.webp',
  handcraft_wood:
    '//s3.marpple.co/files/u_4648126/2025/1/original/67ee666bce0024f84f7a244b615fc868c32d702336.webp',
  handcraft_emboridery:
    '//s3.marpple.co/files/u_4648126/2025/1/original/cdebd2757f50f0c7618d0773ed67c976c2d4d7c135.webp',
  handcraft_paper_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/08716abc8adaa20605cc2b2e7f47456ff31dc01534.webp',
  handcraft_paper:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0e0bb112157ee197440aef84c690438eac9590e133.webp',
  handcraft_paper_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f77a2dc9cb8bfba2631a5fa31a32c23653aa038532.webp',
  handcraft_glass_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/07bde95c75d6ce630f9236cd6fd130381ac8f8ed31.webp',
  handcraft_glass:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f09f83936789d54ecd31343fc5968b360343262630.webp',
  handcraft_glass_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/4d15f072bf01b1e2e2c2b168667dac6ad0c6176f29.webp',
  handcraft_food_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/0833f193f85b5134bb725913eea947220c0f8e8d28.webp',
  handcraft_food_blue:
    '//s3.marpple.co/files/u_4648126/2025/1/original/caef705155361d222dab43b2c6cfbd949c52a31127.webp',
  handcraft_food_yellow:
    '//s3.marpple.co/files/u_4648126/2025/1/original/099f313edfe0a29bef24f35a6baa40c3c46ad9b426.webp',
  handcraft_fluffy_flower:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a45ebd0516ca644770bb704d9de4456169ebf22325.webp',
  handcraft_cosmetic_violet:
    '//s3.marpple.co/files/u_4648126/2025/1/original/2f29f15d4b06081476f7db524d53cf71af154c1824.webp',
  handcraft_cosmetic_green:
    '//s3.marpple.co/files/u_4648126/2025/1/original/a30428ba124c9ecd8f60e7d367db3fbf9cf4847623.webp',
  handcraft_clay_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/ac092125e5a101da2fde6328a7c805495534325e22.webp',
  handcraft_clay:
    '//s3.marpple.co/files/u_4648126/2025/1/original/9b4c520b49c6ef6ebddb539ce441364f5401034621.webp',
  handcraft_clay_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/794a7f34ca2384017d79ed578e99ba8ee59249e620.webp',
  handcraft_clay_3:
    '//s3.marpple.co/files/u_4648126/2025/1/original/25cbe2816eccd3297a95101b23fad96e961d020b19.webp',
  handcraft_candle_comb:
    '//s3.marpple.co/files/u_4648126/2025/1/original/919873e6d76d1abae572e6950b4bb9040afcebbb18.webp',
  handcraft_candle_1:
    '//s3.marpple.co/files/u_4648126/2025/1/original/9e7816678ced74f771d12712c087563e826dbe5f17.webp',
  handcraft_candle_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/8d414e10848c870ce9b02fe2906e75862e96288e16.webp',
  handcraft_candle_3:
    '//s3.marpple.co/files/u_4648126/2025/1/original/48af960a5206704d3474e0fff848d6fed37fd5da15.webp',
  handcraft_myluv:
    '//s3.marpple.co/files/u_4648126/2025/1/original/f1cad05e6438ddb69f0fcc6e2e9fcc16f10a0c3414.webp',
  handcraft_myluv_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/b8995f2c0c37d2aad332980765a59abef9ad79fa13.webp',
  product_ex_chip:
    '//s3.marpple.co/files/u_4648126/2025/1/original/08de558b28af5bb18259a0a79d03fb83c245020d12.webp',
  product_ex_chip_R:
    '//s3.marpple.co/files/u_4648126/2025/1/original/d633f55c88ab4cdb420aa86624f6f112d0b317f111.webp',
  product_ex_icecream:
    '//s3.marpple.co/files/u_4648126/2025/1/original/31459a127c1db5a87c66b1c8cb1f2e30fbed6df210.webp',
  product_ex_icecream_R:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e701e975a701416ad37ba83a1f6b7cf8d304cd589.webp',
  myluv_partner:
    '//s3.marpple.co/files/u_4648126/2025/1/original/16fea23b9149b9204f1e93a8650268573094e3088.webp',
  myluv_ludolf_santa:
    '//s3.marpple.co/files/u_4648126/2025/1/original/d9107d03ba6789aba3903cb13695dc79778358267.webp',
  myluv_santa:
    '//s3.marpple.co/files/u_4648126/2025/1/original/85a500d85b0248732d16f6de4f5c526e0bc2ff266.webp',
  myluv_ludolf:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e9db44ed255ef8329a5ab05a1f2ae4bc11bd9f465.webp',
  myluv_ludolf_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/59159d0d0e22d926a1bc5f147441bf23b03b392e4.webp',
  myluv_ludolf_santa_2:
    '//s3.marpple.co/files/u_4648126/2025/1/original/e2a06fa9b7f3359b4161b49b2d9c45ab6539cac13.webp',
  myluv_santa_box:
    '//s3.marpple.co/files/u_4648126/2025/1/original/5f9bbe0802c139060f1b926514f49d2246be46292.webp',
};
